import { makeAutoObservable, reaction, runInAction } from 'mobx';
import { debounce } from '@xkit-yx/utils';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var loglevel = createCommonjsModule(function (module) {
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    if (module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(commonjsGlobal, function () {

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
        /Trident\/|MSIE /.test(window.navigator.userAgent)
    );

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    var _loggersByName = {};
    var defaultLogger = null;

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) {
                console.log.apply(console, arguments);
            } else {
                // In old IE, native console methods themselves don't have apply().
                Function.prototype.apply.apply(console.log, [console, arguments]);
            }
        }
        if (console.trace) console.trace();
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (methodName === 'trace' && isIE) {
            return traceForIE;
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods() {
        /*jshint validthis:true */
        var level = this.getLevel();

        // Replace the actual methods.
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, this.name);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;

        // Return any important warnings.
        if (typeof console === undefinedType && level < this.levels.SILENT) {
            return "No console available for logging";
        }
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, _level, _loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, factory) {
      // Private instance variables.
      var self = this;
      /**
       * The level inherited from a parent logger (or a global default). We
       * cache this here rather than delegating to the parent so that it stays
       * in sync with the actual logging methods that we have installed (the
       * parent could change levels but we might not have rebuilt the loggers
       * in this child yet).
       * @type {number}
       */
      var inheritedLevel;
      /**
       * The default level for this logger, if any. If set, this overrides
       * `inheritedLevel`.
       * @type {number|null}
       */
      var defaultLevel;
      /**
       * A user-specific level for this logger. If set, this overrides
       * `defaultLevel`.
       * @type {number|null}
       */
      var userLevel;

      var storageKey = "loglevel";
      if (typeof name === "string") {
        storageKey += ":" + name;
      } else if (typeof name === "symbol") {
        storageKey = undefined;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType || !storageKey) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType || !storageKey) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var cookieName = encodeURIComponent(storageKey);
                  var location = cookie.indexOf(cookieName + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(
                          cookie.slice(location + cookieName.length + 1)
                      )[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      function clearPersistedLevel() {
          if (typeof window === undefinedType || !storageKey) return;

          // Use localStorage if available
          try {
              window.localStorage.removeItem(storageKey);
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch (ignore) {}
      }

      function normalizeLevel(input) {
          var level = input;
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              return level;
          } else {
              throw new TypeError("log.setLevel() called with invalid level: " + input);
          }
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          if (userLevel != null) {
            return userLevel;
          } else if (defaultLevel != null) {
            return defaultLevel;
          } else {
            return inheritedLevel;
          }
      };

      self.setLevel = function (level, persist) {
          userLevel = normalizeLevel(level);
          if (persist !== false) {  // defaults to true
              persistLevelIfPossible(userLevel);
          }

          // NOTE: in v2, this should call rebuild(), which updates children.
          return replaceLoggingMethods.call(self);
      };

      self.setDefaultLevel = function (level) {
          defaultLevel = normalizeLevel(level);
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.resetLevel = function () {
          userLevel = null;
          clearPersistedLevel();
          replaceLoggingMethods.call(self);
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      self.rebuild = function () {
          if (defaultLogger !== self) {
              inheritedLevel = normalizeLevel(defaultLogger.getLevel());
          }
          replaceLoggingMethods.call(self);

          if (defaultLogger === self) {
              for (var childName in _loggersByName) {
                _loggersByName[childName].rebuild();
              }
          }
      };

      // Initialize all the internal levels.
      inheritedLevel = normalizeLevel(
          defaultLogger ? defaultLogger.getLevel() : "WARN"
      );
      var initialLevel = getPersistedLevel();
      if (initialLevel != null) {
          userLevel = normalizeLevel(initialLevel);
      }
      replaceLoggingMethods.call(self);
    }

    /*
     *
     * Top-level API
     *
     */

    defaultLogger = new Logger();

    defaultLogger.getLogger = function getLogger(name) {
        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
            throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
            logger = _loggersByName[name] = new Logger(
                name,
                defaultLogger.methodFactory
            );
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    // ES6 default export, for compatibility
    defaultLogger['default'] = defaultLogger;

    return defaultLogger;
}));
});

var e = loglevel;

var c=function(n){var t=void 0===n?{appName:"",version:"",storeWindow:!1}:n,r=t.level,o=t.appName,a=void 0===o?"":o,c=t.version,l=void 0===c?"":c,u=t.storeWindow,i=void 0!==u&&u,s=function(){var e=new Date,n=e.getFullYear(),t=e.getMonth()+1,r=e.getDate(),o=e.getHours()<10?"0".concat(e.getHours()):e.getHours(),a=e.getMinutes()<10?"0".concat(e.getMinutes()):e.getMinutes(),c=e.getSeconds()<10?"0".concat(e.getSeconds()):e.getSeconds();return "".concat(n,"-").concat(t,"-").concat(r," ").concat(o,":").concat(a,":").concat(c)},f=new Proxy(e,{get:function(e,n){if(n in e){var t=e[n];if(!["log","info","warn","error","trace","debug"].includes(n))return t;var r=function(){try{var e=navigator.userAgent.toLocaleLowerCase().match(/(msie|firefox|chrome|opera|version).*?([\d.]+)/)||[];return {browser:e[1].replace(/version/,"safari"),ver:e[2]}}catch(e){return null}}(),o="";return o=r?"[ ".concat(a," ").concat(l," ").concat(r.browser,":").concat(r.ver," ").concat(s()," ]"):"[ ".concat(a," ").concat(l," ").concat(s()," ]"),t.bind(null,o)}}});return r&&f.setLevel(r),i&&(window.__LOGGER__=f),f};

var name = "@xkit-yx/im-store";
var version = "0.2.0";
var description = "云信即时通讯 store";
var license = "MIT";
var main = "dist/index.cjs.js";
var module = "dist/index.esm.js";
var typings = "dist/types/index.d.ts";
var publishConfig = {
	access: "public"
};
var scripts = {
	dev: "rollup -c --environment DEV",
	build: "rollup -c --environment PROD"
};
var files = [
	"dist"
];
var author = "";
var devDependencies = {
	"@rollup/plugin-commonjs": "^17.1.0",
	"@rollup/plugin-json": "^4.1.0",
	"@rollup/plugin-node-resolve": "^11.2.0",
	del: "^6.0.0",
	gulp: "^4.0.2",
	"gulp-less": "^5.0.0",
	"gulp-rename": "^2.0.0",
	"gulp-typescript": "^6.0.0-alpha.1",
	less: "^4.1.1",
	"less-plugin-npm-import": "^2.1.0",
	"nim-web-sdk-ng": "0.17.0",
	postcss: "^8.3.5",
	"postcss-nested": "^5.0.5",
	react: "^16.8.0",
	"react-dom": "^16.8.0",
	rollup: "^2.39.0",
	"rollup-plugin-postcss": "^4.0.0",
	"rollup-plugin-terser": "^7.0.2",
	"rollup-plugin-typescript2": "^0.31.0",
	tslib: "^2.5.0",
	typescript: "^4.6.4"
};
var dependencies = {
	"@xkit-yx/core-kit": "^0.13.0",
	"@xkit-yx/utils": "^0.5.6",
	mobx: "^6.6.1"
};
var packageJson = {
	name: name,
	version: version,
	description: description,
	license: license,
	main: main,
	module: module,
	typings: typings,
	publishConfig: publishConfig,
	scripts: scripts,
	files: files,
	author: author,
	devDependencies: devDependencies,
	dependencies: dependencies
};

var logger = c({
    level: 'debug',
    version: packageJson.version,
    appName: packageJson.name,
});
/**
 * 解析 sessionId，形如 scene-accid
 */
var parseSessionId = function (sessionId) {
    var _a = __read(sessionId.split('-')), scene = _a[0], to = _a.slice(1);
    return {
        scene: scene,
        // 这样处理是为了防止有些用户 accid 中自带 -
        to: to.join('-'),
    };
};
var frequencyControl = function (fn, delay, limit) {
    var promiseQueue = [];
    var requesting = false;
    var timer;
    return function (args) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var p = promiseQueue.find(function (item) { return item.args === args; });
            if (p) {
                p.queue.push({ resolve: resolve, reject: reject });
            }
            else {
                promiseQueue.push({ args: args, queue: [{ resolve: resolve, reject: reject }] });
            }
            if (requesting) {
                return;
            }
            var handler = function (pq) {
                if (!pq.length) {
                    return;
                }
                requesting = true;
                fn.call(
                // @ts-ignore
                _this, pq.map(function (item) { return item.args; }))
                    .then(function (res) {
                    var _loop_1 = function () {
                        var p_1 = pq.shift();
                        if (p_1) {
                            var _1 = res.find(function (j) { return j.account === p_1.args; });
                            p_1.queue.forEach(function (j) { return j.resolve(_1); });
                        }
                    };
                    while (pq.length) {
                        _loop_1();
                    }
                })
                    .catch(function (err) {
                    while (pq.length) {
                        var p_2 = pq.shift();
                        if (p_2) {
                            p_2.queue.forEach(function (item) { return item.reject(err); });
                        }
                    }
                })
                    .finally(function () {
                    requesting = false;
                    if (promiseQueue.length) {
                        handler(promiseQueue.splice(0, limit));
                    }
                });
            };
            // 如果参数数量到达 limit，立即执行
            if (promiseQueue.length >= limit) {
                clearTimeout(timer);
                handler(promiseQueue.splice(0, limit));
            }
            else {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    handler(promiseQueue.splice(0, limit));
                }, delay);
            }
        });
    };
};
/**
 * 过滤消息，处理了撤回消息的过滤
 */
var getFilterMsgs = function (msgs, filterFn) {
    var filterMsgs = __spreadArray([], __read(msgs), false);
    if (filterFn) {
        filterMsgs = filterMsgs.filter(filterFn);
    }
    var res = [];
    var filterRecallMsg = [];
    var startWithoutRecallMsg;
    filterMsgs.forEach(function (item) {
        var _a, _b;
        // 找到第一条不是撤回消息的消息，记录时间
        if (!(item.type === 'custom' &&
            ['beReCallMsg', 'reCallMsg'].includes(((_a = item.attach) === null || _a === void 0 ? void 0 : _a.type) || '')) &&
            startWithoutRecallMsg === void 0) {
            startWithoutRecallMsg = item.time;
        }
        // 不在上述时间范围内的撤回消息过滤掉不显示
        if (item.type === 'custom' &&
            ['beReCallMsg', 'reCallMsg'].includes(((_b = item.attach) === null || _b === void 0 ? void 0 : _b.type) || '')) {
            if (startWithoutRecallMsg !== void 0 &&
                item.time >= startWithoutRecallMsg) {
                res.push(item);
            }
            else {
                filterRecallMsg.push(item);
            }
        }
        else {
            res.push(item);
        }
    });
    // 如果当前只有撤回消息，则需要显示
    if (!res.length && filterRecallMsg.length) {
        return filterRecallMsg;
    }
    return res;
};
var batchRequest = function (fn, max) {
    return function (params) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var batches, i, batches_1, batches_1_1, batch, e_1_1, error_1;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 11, , 12]);
                        if (!!params.length) return [3 /*break*/, 2];
                        // @ts-ignore
                        return [4 /*yield*/, fn.apply(this, [params].concat(args))];
                    case 1:
                        // @ts-ignore
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        batches = [];
                        for (i = 0; i < params.length; i += max) {
                            batches.push(params.slice(i, i + max));
                        }
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 8, 9, 10]);
                        batches_1 = __values(batches), batches_1_1 = batches_1.next();
                        _b.label = 4;
                    case 4:
                        if (!!batches_1_1.done) return [3 /*break*/, 7];
                        batch = batches_1_1.value;
                        return [4 /*yield*/, fn.apply(this, [batch].concat(args))];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        batches_1_1 = batches_1.next();
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (batches_1_1 && !batches_1_1.done && (_a = batches_1.return)) _a.call(batches_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_1 = _b.sent();
                        throw error_1;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
};
var formatScene = function (scene) {
    var map = {
        p2p: 'p2p',
        team: 'team',
        superteam: 'superTeam',
    };
    return map[scene.toLowerCase()] || scene;
};

var utils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    logDebug: c,
    logger: logger,
    parseSessionId: parseSessionId,
    frequencyControl: frequencyControl,
    getFilterMsgs: getFilterMsgs,
    batchRequest: batchRequest,
    formatScene: formatScene
});

/**Mobx 可观察对象，负责连接的子 store */
var ConnectStore = /** @class */ (function () {
    function ConnectStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        /** 连接状态 */
        this.connectState = 'idle';
        makeAutoObservable(this);
        this._onLogined = this._onLogined.bind(this);
        this._onDisconnect = this._onDisconnect.bind(this);
        this._onWillReconnect = this._onWillReconnect.bind(this);
        this._onKicked = this._onKicked.bind(this);
        this._onMultiPortLogin = this._onMultiPortLogin.bind(this);
        this._onSyncDone = this._onSyncDone.bind(this);
        // 连接成功
        nim.on('logined', this._onLogined);
        // 连接断开
        nim.on('disconnect', this._onDisconnect);
        // 开始自动重连
        nim.on('willReconnect', this._onWillReconnect);
        // 被踢下线
        nim.on('kicked', this._onKicked);
        // 多端登录通知
        nim.on('multiPortLogin', this._onMultiPortLogin);
        // 同步完成
        nim.on('syncdone', this._onSyncDone);
        this.connectState = this.nim.connectState;
    }
    /** 销毁 ConnectStore，并取消相关的监听 */
    ConnectStore.prototype.destroy = function () {
        this.nim.off('logined', this._onLogined);
        this.nim.off('disconnect', this._onDisconnect);
        this.nim.off('willReconnect', this._onWillReconnect);
        this.nim.off('kicked', this._onKicked);
        this.nim.off('multiPortLogin', this._onMultiPortLogin);
        this.nim.off('syncdone', this._onSyncDone);
    };
    ConnectStore.prototype._onLogined = function () {
        logger.log('_onLogined');
        this.connectState = 'connected';
        // 重连时需要重置其他人的登录状态
        this.rootStore.eventStore.stateMap.clear();
    };
    ConnectStore.prototype._onDisconnect = function () {
        logger.log('_onDisconnect');
        this.connectState = 'disconnected';
    };
    ConnectStore.prototype._onWillReconnect = function () {
        logger.log('_onWillReconnect');
        this.connectState = 'connecting';
    };
    ConnectStore.prototype._onKicked = function () {
        logger.log('_onKicked');
        this.connectState = 'disconnected';
    };
    ConnectStore.prototype._onMultiPortLogin = function (data) {
        logger.log('_onMultiPortLogin', data);
    };
    ConnectStore.prototype._onSyncDone = function () {
        logger.log('_onSyncDone');
    };
    return ConnectStore;
}());

var SyncFriendActionType;
(function (SyncFriendActionType) {
    // 添加好友
    SyncFriendActionType[SyncFriendActionType["addFriend"] = 0] = "addFriend";
    // 好友申请
    SyncFriendActionType[SyncFriendActionType["applyFriend"] = 1] = "applyFriend";
    // 通过还有申请
    SyncFriendActionType[SyncFriendActionType["passFriendApply"] = 2] = "passFriendApply";
    // 拒绝好友申请
    SyncFriendActionType[SyncFriendActionType["rejectFriendApply"] = 3] = "rejectFriendApply";
    // 删除好友
    SyncFriendActionType[SyncFriendActionType["deleteFriend"] = 4] = "deleteFriend";
    // 更新好友备注
    SyncFriendActionType[SyncFriendActionType["updateFriend"] = 5] = "updateFriend";
})(SyncFriendActionType || (SyncFriendActionType = {}));
/**Mobx 可观察对象，负责管理好友信息的子 store */
var FriendStore = /** @class */ (function () {
    function FriendStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.friends = new Map();
        makeAutoObservable(this);
        this._onFriends = this._onFriends.bind(this);
        this._onSyncFriend = this._onSyncFriend.bind(this);
        // 好友信息
        nim.on('friends', this._onFriends);
        // 多端同步好友操作
        nim.on('syncFriend', this._onSyncFriend);
    }
    /**
     * 销毁FriendStore，会取消好友事件监听
     */
    FriendStore.prototype.destroy = function () {
        this.nim.off('friends', this._onFriends);
        this.nim.off('syncFriend', this._onSyncFriend);
    };
    /**
     * 通过好友申请
     * @param account 账号
     */
    FriendStore.prototype.passFriendApplyActive = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('passFriendApplyActive', account);
                        return [4 /*yield*/, this.nim.passFriendApply({ account: account, ps: '' })
                            // 本端会收到 updateSysMsg，其他多端会收到 syncFriend
                            // 可是 IM1 updateSysMsg 有问题，因此还得在这边手动处理
                        ];
                    case 1:
                        _a.sent();
                        // 本端会收到 updateSysMsg，其他多端会收到 syncFriend
                        // 可是 IM1 updateSysMsg 有问题，因此还得在这边手动处理
                        this.rootStore.sysMsgStore.updateApplyMsg({
                            state: 'pass',
                            from: account,
                            type: 'friendRequest',
                            to: this.rootStore.userStore.myUserInfo.account,
                        });
                        this.rootStore.sysMsgStore.deleteUnReadSysMsgs('friendRequest', account, this.rootStore.userStore.myUserInfo.account);
                        logger.log('passFriendApplyActive success', account);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger.error('passFriendApplyActive failed: ', account, error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 拒绝好友申请
     * @param account 账号
     */
    FriendStore.prototype.rejectFriendApplyActive = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('rejectFriendApplyActive', account);
                        return [4 /*yield*/, this.nim.rejectFriendApply({ account: account, ps: '' })
                            // 本端会收到 updateSysMsg，其他多端会收到 syncFriend
                            // 可是 IM1 updateSysMsg 有问题，因此还得在这边手动处理
                        ];
                    case 1:
                        _a.sent();
                        // 本端会收到 updateSysMsg，其他多端会收到 syncFriend
                        // 可是 IM1 updateSysMsg 有问题，因此还得在这边手动处理
                        this.rootStore.sysMsgStore.updateApplyMsg({
                            state: 'decline',
                            from: account,
                            type: 'friendRequest',
                            to: this.rootStore.userStore.myUserInfo.account,
                        });
                        this.rootStore.sysMsgStore.deleteUnReadSysMsgs('friendRequest', account, this.rootStore.userStore.myUserInfo.account);
                        logger.log('rejectFriendApplyActive success', account);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        logger.error('rejectFriendApplyActive failed: ', account, error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 直接添加好友
     * @param account 账号
     */
    FriendStore.prototype.addFriendActive = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('addFriendActive', account);
                        return [4 /*yield*/, this.nim.addFriend({ account: account })];
                    case 1:
                        res = _a.sent();
                        this.addFriend([res]);
                        logger.log('addFriendActive success', account);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        logger.error('addFriendActive failed: ', account, error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 添加好友申请
     * @param account 账号
     */
    FriendStore.prototype.applyFriendActive = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('applyFriendActive', account);
                        return [4 /*yield*/, this.nim.applyFriend({ account: account })];
                    case 1:
                        _a.sent();
                        logger.log('applyFriendActive success', account);
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        logger.error('applyFriendActive failed: ', account, error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 删除好友
     * @param account 账号
     */
    FriendStore.prototype.deleteFriendActive = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('deleteFriendActive', account);
                        return [4 /*yield*/, this.nim.deleteFriend({ account: account, delAlias: true })];
                    case 1:
                        _a.sent();
                        this.removeFriend([account]);
                        // 业务需要，移除黑名单。uniapp v1.1.0 版本中，该操作挪到 demo 层添加好友及申请添加好友后。
                        // await this.rootStore.relationStore.setBlackActive({
                        //   account,
                        //   isAdd: false,
                        // })
                        logger.log('deleteFriendActive success', account);
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        logger.error('deleteFriendActive failed: ', account, error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 更新好友信息
     * @param account 账号
     * @param account 备注
     */
    FriendStore.prototype.updateFriendActive = function (account, alias) {
        return __awaiter(this, void 0, void 0, function () {
            var error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('updateFriendActive', account, alias);
                        return [4 /*yield*/, this.nim.updateFriend({ account: account, alias: alias })
                            // 本端没有事件，需要手动处理
                        ];
                    case 1:
                        _a.sent();
                        // 本端没有事件，需要手动处理
                        this.addFriend([
                            {
                                account: account,
                                alias: alias,
                                updateTime: Date.now(),
                                createTime: Date.now(),
                                valid: true,
                            },
                        ]);
                        logger.log('updateFriendActive success', account, alias);
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        logger.error('updateFriendActive failed: ', account, alias, error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * FriendStore添加好友处理函数（FriendStore内部使用，外层不太推荐直接使用）
     * @param data - 好友数组
     */
    FriendStore.prototype.addFriend = function (data) {
        var _this = this;
        data
            // 更新时可能没有 valid 字段，因此全等过滤不等于false 的
            .filter(function (item) { return item.valid !== false; })
            .filter(function (item) { return !!item.account; })
            .forEach(function (item) {
            var oldFriend = _this.friends.get(item.account);
            if (!oldFriend) {
                _this.friends.set(item.account, item);
                _this.rootStore.userStore.getUserActive(item.account);
            }
            else {
                _this.friends.set(item.account, __assign(__assign({}, oldFriend), item));
            }
        });
    };
    /**
     * FriendStore删除好友处理函数（FriendStore内部使用，外层不太推荐直接使用）
     * @param data - 好友数组
     */
    FriendStore.prototype.removeFriend = function (accounts) {
        var _this = this;
        accounts.forEach(function (item) {
            _this.friends.delete(item);
        });
    };
    FriendStore.prototype._onFriends = function (data) {
        logger.log('_onFriends: ', data);
        this.addFriend(data);
    };
    FriendStore.prototype._onSyncFriend = function (data) {
        logger.log('_onSyncFriend: ', data);
        switch (data.type) {
            case 'addFriend':
            case 'updateFriend':
                if (data.friend) {
                    this.addFriend([data.friend]);
                }
                break;
            case 'deleteFriend':
                if (data.account) {
                    this.removeFriend([data.account]);
                }
                break;
            case 'passFriendApply':
                this.rootStore.sysMsgStore.updateApplyMsg({
                    from: data.account || '',
                    state: 'pass',
                    type: 'friendRequest',
                    to: this.rootStore.userStore.myUserInfo.account,
                });
                break;
            case 'rejectFriendApply':
                this.rootStore.sysMsgStore.updateApplyMsg({
                    from: data.account || '',
                    state: 'decline',
                    type: 'friendRequest',
                    to: this.rootStore.userStore.myUserInfo.account,
                });
                break;
        }
    };
    return FriendStore;
}());

var AT_ALL_ACCOUNT = 'ait_all';
var BE_MENTIONED = 'beMentioned';
var AT_ALL_ACCOUNT_TOSDK = '#%@all@%#';
var HISTORY_LIMIT = 20;
var RECALL_TIME = 2 * 60 * 1000;

var constant = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AT_ALL_ACCOUNT: AT_ALL_ACCOUNT,
    BE_MENTIONED: BE_MENTIONED,
    AT_ALL_ACCOUNT_TOSDK: AT_ALL_ACCOUNT_TOSDK,
    HISTORY_LIMIT: HISTORY_LIMIT,
    RECALL_TIME: RECALL_TIME
});

var Queue = /** @class */ (function () {
    /**
     * @param itemLength 队列长度
     * @param flow 队列方向
     */
    function Queue(itemLength, flow) {
        if (itemLength === void 0) { itemLength = 20; }
        if (flow === void 0) { flow = 'rightToLeft'; }
        this.itemLength = itemLength;
        this.flow = flow;
        this.queue = [];
        makeAutoObservable(this);
    }
    Queue.prototype.push = function (item, noLimit) {
        this.queue.push(item);
        this._handle(noLimit);
    };
    Queue.prototype.unshift = function (item, noLimit) {
        this.queue.unshift(item);
        this._handle(noLimit);
    };
    Queue.prototype.pop = function () {
        return this.queue.pop();
    };
    Queue.prototype.shift = function () {
        return this.queue.shift();
    };
    Queue.prototype.resetLimitState = function () {
        this._handle();
    };
    Queue.prototype.clear = function () {
        this.queue.length = 0;
    };
    Queue.prototype.get = function () {
        return this.queue;
    };
    Queue.prototype.set = function (value, noLimit) {
        this.queue = value;
        this._handle(noLimit);
    };
    Object.defineProperty(Queue.prototype, "length", {
        get: function () {
            return this.queue.length;
        },
        enumerable: false,
        configurable: true
    });
    Queue.prototype._handle = function (noLimit) {
        if (noLimit === void 0) { noLimit = false; }
        if (this.queue.length > this.itemLength && !noLimit) {
            if (this.flow === 'leftToRight') {
                this.queue.splice(this.itemLength, this.queue.length - this.itemLength);
            }
            else {
                this.queue.splice(0, this.queue.length - this.itemLength);
            }
        }
    };
    return Queue;
}());
var QueueMap = /** @class */ (function () {
    function QueueMap(itemLength, flow) {
        if (itemLength === void 0) { itemLength = 20; }
        if (flow === void 0) { flow = 'rightToLeft'; }
        this.itemLength = itemLength;
        this.flow = flow;
        this.map = new Map();
        makeAutoObservable(this);
    }
    QueueMap.prototype.get = function (key) {
        var _a;
        return (_a = this.map.get(key)) === null || _a === void 0 ? void 0 : _a.get();
    };
    QueueMap.prototype.set = function (key, value, noLimit) {
        var queue = new Queue(this.itemLength, this.flow);
        queue.set(value, noLimit);
        this.map.set(key, queue);
    };
    QueueMap.prototype.delete = function (key) {
        var _a;
        (_a = this.map.get(key)) === null || _a === void 0 ? void 0 : _a.clear();
        return this.map.delete(key);
    };
    QueueMap.prototype.resetLimitState = function () {
        this.map.forEach(function (item) { return item.resetLimitState(); });
    };
    QueueMap.prototype.clear = function () {
        this.map.forEach(function (item) { return item.clear(); });
        this.map.clear();
    };
    QueueMap.prototype.values = function () {
        return __spreadArray([], __read(this.map.values()), false).map(function (item) { return item.get(); }).flat();
    };
    return QueueMap;
}());

/**Mobx 可观察对象，负责管理会话消息的子 store */
var MsgStore = /** @class */ (function () {
    function MsgStore(rootStore, nim, localOptions) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.localOptions = localOptions;
        this.msgs = new QueueMap(HISTORY_LIMIT, 'rightToLeft');
        /** 回复消息 */
        this.replyMsgs = new Map();
        makeAutoObservable(this);
        this._onMsg = this._onMsg.bind(this);
        // this._onSyncOfflineMsgs = this._onSyncOfflineMsgs.bind(this)
        // this._onSyncRoamingMsgs = this._onSyncRoamingMsgs.bind(this)
        this._onTeamMsgReceipts = this._onTeamMsgReceipts.bind(this);
        this._onDeleteSelfMsgs = this._onDeleteSelfMsgs.bind(this);
        this._handleTeamMsgReadStatus = batchRequest(this._handleTeamMsgReadStatus, 50);
        // 收到消息
        nim.on('msg', this._onMsg);
        // 同步时离线消息
        // nim.on('syncOfflineMsgs', this._onSyncOfflineMsgs)
        // 同步时漫游消息
        // nim.on('syncRoamingMsgs', this._onSyncRoamingMsgs)
        // 群已读
        nim.on('teamMsgReceipts', this._onTeamMsgReceipts);
        // 多端同步单向删除某消息的通知
        nim.on('deleteSelfMsgs', this._onDeleteSelfMsgs);
    }
    /**
     * 销毁MsgStore，会取消消息相关事件监听
     */
    MsgStore.prototype.destroy = function () {
        var _this = this;
        this.nim.off('msg', this._onMsg);
        // this.nim.off('syncOfflineMsgs', this._onSyncOfflineMsgs)
        // this.nim.off('syncRoamingMsgs', this._onSyncRoamingMsgs)
        this.nim.off('teamMsgReceipts', this._onTeamMsgReceipts);
        this.nim.off('deleteSelfMsgs', this._onDeleteSelfMsgs);
        this.getMsg().forEach(function (msg) {
            _this._handleClearMsgTimer(msg);
        });
    };
    /**
     * 回复消息
     * @param msg 消息对象
     */
    MsgStore.prototype.replyMsgActive = function (msg) {
        this.replyMsgs.set(msg.sessionId, msg);
    };
    /**
     * 回复消息
     * @param msg 消息对象
     */
    MsgStore.prototype.removeReplyMsgActive = function (sessionId) {
        this.replyMsgs.delete(sessionId);
    };
    /**
     * 撤回消息
     * @param msg 消息对象
     */
    MsgStore.prototype.reCallMsgActive = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var attach, recallMsg_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('reCallMsgActive', msg);
                        return [4 /*yield*/, this.nim.recallMsg({ msg: msg })];
                    case 1:
                        _a.sent();
                        this.removeMsg(msg.sessionId, [msg.idClient]);
                        attach = {
                            type: 'reCallMsg',
                        };
                        if (msg.type === 'custom' || msg.type === 'text') {
                            attach.oldBody = msg.body;
                            attach.canEdit = true;
                            attach.canEditTimer = setTimeout(function () {
                                _this.addMsg(recallMsg_1.sessionId, [
                                    __assign(__assign({}, recallMsg_1), { attach: __assign(__assign({}, recallMsg_1.attach), { canEdit: false }) }),
                                ]);
                            }, RECALL_TIME);
                        }
                        recallMsg_1 = __assign(__assign({}, msg), { idClient: "reCall-".concat(msg.idClient), status: 'sent', time: Date.now(), userUpdateTime: Date.now(), type: 'custom', body: '', feature: 'default', attach: attach });
                        this.addMsg(recallMsg_1.sessionId, [recallMsg_1]);
                        logger.log('reCallMsgActive success', msg);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger.error('reCallMsgActive failed: ', msg, error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 插入一条对方撤回的自定义消息
     * @param __namedParameters.scene - 场景
     * @param __namedParameters.from - 消息发送方帐号
     * @param __namedParameters.to - 接收方, 对方帐号或者群id
     * @param __namedParameters.idClient - 端测生成的消息id, 可作为消息唯一主键使用
     * @param __namedParameters.time - 消息发送成功的时间戳(单位毫秒)
     */
    MsgStore.prototype.beReCallMsgActive = function (_a) {
        var _b;
        var scene = _a.scene, from = _a.from, to = _a.to, idClient = _a.idClient, time = _a.time;
        logger.log('beReCallMsgActive', {
            scene: scene,
            from: from,
            to: to,
            idClient: idClient,
            time: time,
        });
        var sessionId = this.rootStore.sessionStore.getSessionId(scene, from, to);
        this.removeMsg(sessionId, [idClient]);
        // // 可能是多端同步过来的消息
        var isSelf = ((_b = this.rootStore.userStore.myUserInfo) === null || _b === void 0 ? void 0 : _b.account) === from;
        // 插入一条对方撤回的自定义消息。目前是直接插入内存，如果需要记录到服务端，各端统一好格式，发送一条真实的自定义消息。
        var beRecallMsg = {
            idClient: "reCall-".concat(idClient),
            target: to,
            flow: isSelf ? 'out' : 'in',
            sessionId: sessionId,
            from: from,
            to: to,
            status: 'sent',
            scene: scene,
            time: time,
            userUpdateTime: Date.now(),
            type: 'custom',
            // 因为还要考虑群昵称、备注、昵称这些复杂情况，这边不再提供 body，渲染者自行渲染
            body: '',
            // body: `${isSelf ? this.t('you') : fromNick || from} ${this.t(
            //   'recallMessageText'
            // )}`,
            feature: 'default',
            attach: {
                type: 'beReCallMsg',
            },
        };
        this.addMsg(sessionId, [beRecallMsg]);
    };
    /**
     * 单向删除消息
     * @param msgs 消息对象数组
     */
    MsgStore.prototype.deleteMsgActive = function (msgs) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('deleteMsgActive', msgs);
                        return [4 /*yield*/, this.nim.deleteSelfMsgs({ msgs: msgs })];
                    case 1:
                        res = _a.sent();
                        this._onDeleteSelfMsgs(res);
                        logger.log('deleteMsgActive success', msgs);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        this._onDeleteSelfMsgs(msgs);
                        logger.warn('deleteMsgActive failed, but delete msgs from memory: ', msgs, error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 通过 NIMSDK实例 发送自定义消息
     * @param cb 调用NIMSDK实例上发送消息接口的回调，参数为NIMSDK实例
     */
    MsgStore.prototype.sendCustomMsgBySDK = function (cb) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('sendCustomMsgBySDK');
                        return [4 /*yield*/, cb(this.nim.getNIM())];
                    case 1:
                        res = _a.sent();
                        this._handleSendMsgSuccess(res);
                        logger.log('sendCustomMsgBySDK success', res);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        this._handleSendMsgFail(error_3.msg);
                        logger.error('sendCustomMsgBySDK failed: ', error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 发送自定义消息
     * @param __namedParameters.to - 接收方, 对方帐号或者群id
     * @param __namedParameters.scene - 场景
     * @param __namedParameters.body - 发送内容
     * @param __namedParameters.attach - 附件信息
     */
    MsgStore.prototype.sendCustomMsgActive = function (_a) {
        var scene = _a.scene, to = _a.to, body = _a.body, attach = _a.attach;
        return __awaiter(this, void 0, void 0, function () {
            var options, res, error_4;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        logger.log('sendCustomMsgActive', { scene: scene, to: to, body: body });
                        options = {
                            scene: scene,
                            to: to,
                            ext: this._formatExtField("".concat(scene, "-").concat(to)),
                            body: body,
                            attach: attach,
                            // @ts-ignore
                            teamSpecializationInfo: {
                                needACK: true,
                            },
                            onSendBefore: function (msg) {
                                _this.addMsg(msg.sessionId, [msg]);
                            },
                        };
                        return [4 /*yield*/, this.localOptions.sendMsgBefore(options, 'custom')];
                    case 1:
                        // this.removeReplyMsgActive(`${scene}-${to}`)
                        options = _b.sent();
                        return [4 /*yield*/, this.nim.sendCustomMsg(options)];
                    case 2:
                        res = _b.sent();
                        this._handleSendMsgSuccess(res);
                        logger.log('sendCustomMsgActive success', { scene: scene, to: to, body: body, res: res });
                        return [2 /*return*/, res];
                    case 3:
                        error_4 = _b.sent();
                        this._handleSendMsgFail(error_4.msg);
                        logger.error('sendCustomMsgActive failed: ', { scene: scene, to: to, body: body }, error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 发送文件消息
     * @param __namedParameters.to - 接收方, 对方帐号或者群id
     * @param __namedParameters.scene - 场景
     * @param __namedParameters.file - 文件对象
     * @param __namedParameters.filePath - 文件路径
     */
    MsgStore.prototype.sendFileMsgActive = function (_a) {
        var scene = _a.scene, to = _a.to, file = _a.file, filePath = _a.filePath;
        return __awaiter(this, void 0, void 0, function () {
            var options, res, error_5;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        logger.log('sendFileMsgActive', { scene: scene, to: to, file: file, filePath: filePath });
                        options = {
                            scene: scene,
                            to: to,
                            ext: this._formatExtField("".concat(scene, "-").concat(to)),
                            file: file,
                            filePath: filePath,
                            // @ts-ignore
                            teamSpecializationInfo: {
                                needACK: true,
                            },
                            onUploadStart: function () {
                                _this.rootStore.uiStore.setUploadFileLoading(true);
                            },
                            onUploadDone: function () {
                                _this.rootStore.uiStore.setUploadFileLoading(false);
                            },
                            onSendBefore: function (msg) {
                                _this.addMsg(msg.sessionId, [msg]);
                            },
                        };
                        return [4 /*yield*/, this.localOptions.sendMsgBefore(options, 'file')];
                    case 1:
                        // 暂不支持文件消息回复其他消息, 其他端（ios、android）会展示异常
                        // this.removeReplyMsgActive(`${scene}-${to}`)
                        options = _b.sent();
                        return [4 /*yield*/, this.nim.sendFileMsg(options)];
                    case 2:
                        res = _b.sent();
                        this._handleSendMsgSuccess(res);
                        logger.log('sendFileMsgActive success', {
                            scene: scene,
                            to: to,
                            file: file,
                            filePath: filePath,
                            res: res,
                        });
                        return [2 /*return*/, res];
                    case 3:
                        error_5 = _b.sent();
                        this._handleSendMsgFail(error_5.msg);
                        logger.error('sendFileMsgActive failed: ', { scene: scene, to: to, file: file, filePath: filePath }, error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 发送图片消息
     * @param __namedParameters.to - 接收方, 对方帐号或者群id
     * @param __namedParameters.scene - 场景
     * @param __namedParameters.file - 图片对象
     * @param __namedParameters.filePath - 图片路径
     * @param __namedParameters.randomId - 上传时的随机 idClient，用于重新发送上传失败的消息
     * @param __namedParameters.previewImg - 上传中的预览图片，不传则使用默认图片
     * @param __namedParameters.onUploadStart - 上传前回调，可以在此回调中取消上传
     * @param __namedParameters.onUploadDone - 上传成功回调
     */
    MsgStore.prototype.sendImageMsgActive = function (_a) {
        var _b, _c;
        var scene = _a.scene, to = _a.to, file = _a.file, filePath = _a.filePath, randomId = _a.randomId, previewImg = _a.previewImg, onUploadStart = _a.onUploadStart, onUploadDone = _a.onUploadDone;
        return __awaiter(this, void 0, void 0, function () {
            var tempMsg, options, res, error_6;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        randomId = randomId || Math.random().toString(36).slice(2);
                        tempMsg = this._createUploadMsg({
                            idClient: randomId,
                            scene: scene,
                            to: to,
                            type: 'image',
                        });
                        // @ts-ignore
                        tempMsg.previewImg = previewImg;
                        // @ts-ignore
                        tempMsg.uploadFileInfo = {
                            file: file,
                            filePath: filePath,
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        logger.log('sendImageMsgActive', { scene: scene, to: to, file: file, filePath: filePath });
                        options = {
                            scene: scene,
                            to: to,
                            ext: this._formatExtField("".concat(scene, "-").concat(to)),
                            file: file,
                            filePath: filePath,
                            // @ts-ignore
                            teamSpecializationInfo: {
                                needACK: true,
                            },
                            onUploadStart: function (obj) {
                                // this.rootStore.uiStore.setUploadImageLoading(true)
                                _this.addMsg(tempMsg.sessionId, [
                                    __assign(__assign({}, tempMsg), { time: Date.now(), uploadProgress: 0 }),
                                ]);
                                onUploadStart === null || onUploadStart === void 0 ? void 0 : onUploadStart(obj, randomId);
                            },
                            onUploadDone: function (obj) {
                                // this.rootStore.uiStore.setUploadImageLoading(false)
                                onUploadDone === null || onUploadDone === void 0 ? void 0 : onUploadDone(randomId);
                                _this.addMsg(tempMsg.sessionId, [
                                    __assign(__assign({}, tempMsg), { uploadProgress: 100 }),
                                ]);
                            },
                            onUploadProgress: function (obj) {
                                _this.addMsg(tempMsg.sessionId, [
                                    __assign(__assign({}, tempMsg), { 
                                        // @ts-ignore
                                        uploadProgress: parseInt((obj.loaded / obj.total) * 100) }),
                                ]);
                            },
                            onSendBefore: function (msg) {
                                _this.removeMsg(tempMsg.sessionId, [tempMsg.idClient]);
                                _this.addMsg(msg.sessionId, [msg]);
                            },
                        };
                        return [4 /*yield*/, this.localOptions.sendMsgBefore(options, 'image')];
                    case 2:
                        // 暂不支持图片消息回复其他消息，其他端（ios、android）会展示异常
                        // this.removeReplyMsgActive(`${scene}-${to}`)
                        options = _d.sent();
                        return [4 /*yield*/, this.nim.sendImageMsg(options)];
                    case 3:
                        res = _d.sent();
                        this._handleSendMsgSuccess(res);
                        logger.log('sendImageMsgActive success', {
                            scene: scene,
                            to: to,
                            file: file,
                            filePath: filePath,
                            res: res,
                        });
                        return [2 /*return*/, res];
                    case 4:
                        error_6 = _d.sent();
                        // 上传失败
                        if (error_6.name === 'uploadError') {
                            // 手动取消
                            if (((_b = error_6.rawError) === null || _b === void 0 ? void 0 : _b.errCode) == 10499 ||
                                ((_c = error_6.rawError) === null || _c === void 0 ? void 0 : _c.errCode) === 'RequestAbortedError') {
                                this.removeMsg(tempMsg.sessionId, [tempMsg.idClient]);
                            }
                            // 其他上传失败
                            else {
                                this.addMsg(tempMsg.sessionId, [__assign(__assign({}, tempMsg), { status: 'sendFailed' })]);
                            }
                        }
                        // 发送失败
                        else {
                            this._handleSendMsgFail(error_6.msg);
                        }
                        logger.error('sendImageMsgActive failed: ', { scene: scene, to: to, file: file, filePath: filePath }, error_6);
                        throw error_6;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 发送视频消息
     * @param __namedParameters.to - 接收方, 对方帐号或者群id
     * @param __namedParameters.scene - 场景
     * @param __namedParameters.file - 视频对象
     * @param __namedParameters.filePath - 视频路径
     * @param __namedParameters.randomId - 上传时的随机 idClient，用于重新发送上传失败的消息
     * @param __namedParameters.previewImg - 上传中的预览图片，不传则使用默认图片
     * @param __namedParameters.onUploadStart - 上传前回调，可以在此回调中取消上传
     * @param __namedParameters.onUploadDone - 上传成功回调
     */
    MsgStore.prototype.sendVideoMsgActive = function (_a) {
        var _b, _c;
        var scene = _a.scene, to = _a.to, file = _a.file, filePath = _a.filePath, randomId = _a.randomId, previewImg = _a.previewImg, onUploadStart = _a.onUploadStart, onUploadDone = _a.onUploadDone;
        return __awaiter(this, void 0, void 0, function () {
            var tempMsg, options, res, error_7;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        randomId = randomId || Math.random().toString(36).slice(2);
                        tempMsg = this._createUploadMsg({
                            idClient: randomId,
                            scene: scene,
                            to: to,
                            type: 'video',
                        });
                        // @ts-ignore
                        tempMsg.previewImg = previewImg;
                        // @ts-ignore
                        tempMsg.uploadFileInfo = {
                            file: file,
                            filePath: filePath,
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        logger.log('sendVideoMsgActive', { scene: scene, to: to, file: file, filePath: filePath });
                        options = {
                            scene: scene,
                            to: to,
                            ext: this._formatExtField("".concat(scene, "-").concat(to)),
                            file: file,
                            filePath: filePath,
                            // @ts-ignore
                            teamSpecializationInfo: {
                                needACK: true,
                            },
                            onUploadStart: function (obj) {
                                _this.addMsg(tempMsg.sessionId, [
                                    __assign(__assign({}, tempMsg), { time: Date.now(), uploadProgress: 0 }),
                                ]);
                                onUploadStart === null || onUploadStart === void 0 ? void 0 : onUploadStart(obj, randomId);
                            },
                            onUploadDone: function (obj) {
                                onUploadDone === null || onUploadDone === void 0 ? void 0 : onUploadDone(randomId);
                                _this.addMsg(tempMsg.sessionId, [
                                    __assign(__assign({}, tempMsg), { uploadProgress: 100 }),
                                ]);
                            },
                            onUploadProgress: function (obj) {
                                _this.addMsg(tempMsg.sessionId, [
                                    __assign(__assign({}, tempMsg), { 
                                        // @ts-ignore
                                        uploadProgress: parseInt((obj.loaded / obj.total) * 100) }),
                                ]);
                            },
                            onSendBefore: function (msg) {
                                _this.removeMsg(tempMsg.sessionId, [tempMsg.idClient]);
                                _this.addMsg(msg.sessionId, [msg]);
                            },
                        };
                        return [4 /*yield*/, this.localOptions.sendMsgBefore(options, 'video')];
                    case 2:
                        // 暂不支持视频消息回复其他消息
                        options = _d.sent();
                        return [4 /*yield*/, this.nim.sendVideoMsg(options)];
                    case 3:
                        res = _d.sent();
                        this._handleSendMsgSuccess(res);
                        logger.log('sendVideoMsgActive success', {
                            scene: scene,
                            to: to,
                            file: file,
                            filePath: filePath,
                            res: res,
                        });
                        return [2 /*return*/, res];
                    case 4:
                        error_7 = _d.sent();
                        // 上传失败
                        if ((error_7 === null || error_7 === void 0 ? void 0 : error_7.name) === 'uploadError') {
                            // 手动取消
                            if (((_b = error_7.rawError) === null || _b === void 0 ? void 0 : _b.errCode) == 10499 ||
                                ((_c = error_7.rawError) === null || _c === void 0 ? void 0 : _c.errCode) === 'RequestAbortedError') {
                                this.removeMsg(tempMsg.sessionId, [tempMsg.idClient]);
                            }
                            // 其他上传失败
                            else {
                                this.addMsg(tempMsg.sessionId, [__assign(__assign({}, tempMsg), { status: 'sendFailed' })]);
                            }
                        }
                        // 发送失败
                        else {
                            this._handleSendMsgFail(error_7.msg);
                        }
                        logger.error('sendVideoMsgActive failed: ', { scene: scene, to: to, file: file, filePath: filePath }, error_7);
                        throw error_7;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 发送音频消息
     * @param __namedParameters.to - 接收方, 对方帐号或者群id
     * @param __namedParameters.scene - 场景
     * @param __namedParameters.file - 音频对象
     * @param __namedParameters.filePath - 音频路径
     * @param __namedParameters.randomId - 上传时的随机 idClient，用于重新发送上传失败的消息
     * @param __namedParameters.onUploadStart - 上传前回调，可以在此回调中取消上传
     * @param __namedParameters.onUploadDone - 上传成功回调
     */
    MsgStore.prototype.sendAudioMsgActive = function (_a) {
        var _b, _c;
        var scene = _a.scene, to = _a.to, file = _a.file, filePath = _a.filePath, randomId = _a.randomId, onUploadStart = _a.onUploadStart, onUploadDone = _a.onUploadDone;
        return __awaiter(this, void 0, void 0, function () {
            var tempMsg, options, res, error_8;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        randomId = randomId || Math.random().toString(36).slice(2);
                        tempMsg = this._createUploadMsg({
                            idClient: randomId,
                            scene: scene,
                            to: to,
                            type: 'audio',
                        });
                        // @ts-ignore
                        tempMsg.uploadFileInfo = {
                            file: file,
                            filePath: filePath,
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        logger.log('sendAudioMsgActive', { scene: scene, to: to, file: file, filePath: filePath });
                        options = {
                            scene: scene,
                            to: to,
                            ext: this._formatExtField("".concat(scene, "-").concat(to)),
                            file: file,
                            filePath: filePath,
                            // @ts-ignore
                            teamSpecializationInfo: {
                                needACK: true,
                            },
                            onUploadStart: function (obj) {
                                _this.addMsg(tempMsg.sessionId, [
                                    __assign(__assign({}, tempMsg), { time: Date.now(), uploadProgress: 0 }),
                                ]);
                                onUploadStart === null || onUploadStart === void 0 ? void 0 : onUploadStart(obj, randomId);
                            },
                            onUploadDone: function (obj) {
                                onUploadDone === null || onUploadDone === void 0 ? void 0 : onUploadDone(randomId);
                                _this.addMsg(tempMsg.sessionId, [
                                    __assign(__assign({}, tempMsg), { uploadProgress: 100 }),
                                ]);
                            },
                            onUploadProgress: function (obj) {
                                _this.addMsg(tempMsg.sessionId, [
                                    __assign(__assign({}, tempMsg), { 
                                        // @ts-ignore
                                        uploadProgress: parseInt((obj.loaded / obj.total) * 100) }),
                                ]);
                            },
                            onSendBefore: function (msg) {
                                _this.removeMsg(tempMsg.sessionId, [tempMsg.idClient]);
                                _this.addMsg(msg.sessionId, [msg]);
                            },
                        };
                        return [4 /*yield*/, this.localOptions.sendMsgBefore(options, 'audio')];
                    case 2:
                        // 暂不支持音频消息回复其他消息
                        options = _d.sent();
                        return [4 /*yield*/, this.nim.sendAudioMsg(options)];
                    case 3:
                        res = _d.sent();
                        this._handleSendMsgSuccess(res);
                        logger.log('sendAudioMsgActive success', {
                            scene: scene,
                            to: to,
                            file: file,
                            filePath: filePath,
                            res: res,
                        });
                        return [2 /*return*/, res];
                    case 4:
                        error_8 = _d.sent();
                        // 上传失败
                        if (error_8.name === 'uploadError') {
                            // 手动取消
                            if (((_b = error_8.rawError) === null || _b === void 0 ? void 0 : _b.errCode) == 10499 ||
                                ((_c = error_8.rawError) === null || _c === void 0 ? void 0 : _c.errCode) === 'RequestAbortedError') {
                                this.removeMsg(tempMsg.sessionId, [tempMsg.idClient]);
                            }
                            // 其他上传失败
                            else {
                                this.addMsg(tempMsg.sessionId, [__assign(__assign({}, tempMsg), { status: 'sendFailed' })]);
                            }
                        }
                        // 发送失败
                        else {
                            this._handleSendMsgFail(error_8.msg);
                        }
                        logger.error('sendAudioMsgActive failed: ', { scene: scene, to: to, file: file, filePath: filePath }, error_8);
                        throw error_8;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 发送文本消息
     * @param __namedParameters.to - 接收方, 对方帐号或者群id
     * @param __namedParameters.scene - 场景
     * @param __namedParameters.body - 发送内容
     */
    MsgStore.prototype.sendTextMsgActive = function (_a) {
        var scene = _a.scene, to = _a.to, body = _a.body, ext = _a.ext;
        return __awaiter(this, void 0, void 0, function () {
            var options, res, error_9;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        logger.log('sendTextMsgActive', { scene: scene, to: to, body: body, ext: ext });
                        options = {
                            scene: scene,
                            to: to,
                            ext: this._formatExtField("".concat(scene, "-").concat(to), ext),
                            body: body,
                            // @ts-ignore
                            teamSpecializationInfo: {
                                needACK: true,
                            },
                            pushInfo: (ext === null || ext === void 0 ? void 0 : ext.yxAitMsg)
                                ? this._formatExtAitToPushInfo(ext === null || ext === void 0 ? void 0 : ext.yxAitMsg, body)
                                : undefined,
                            onSendBefore: function (msg) {
                                _this.addMsg(msg.sessionId, [msg]);
                            },
                        };
                        this.removeReplyMsgActive("".concat(scene, "-").concat(to));
                        return [4 /*yield*/, this.localOptions.sendMsgBefore(options, 'text')];
                    case 1:
                        options = _b.sent();
                        return [4 /*yield*/, this.nim.sendTextMsg(options)];
                    case 2:
                        res = _b.sent();
                        this._handleSendMsgSuccess(res);
                        logger.log('sendTextMsgActive success', { scene: scene, to: to, body: body, res: res });
                        return [2 /*return*/, res];
                    case 3:
                        error_9 = _b.sent();
                        this._handleSendMsgFail(error_9.msg);
                        logger.error('sendTextMsgActive failed: ', { scene: scene, to: to, body: body }, error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 消息重发
     * @param msg 消息对象
     */
    MsgStore.prototype.resendMsgActive = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('resendMsgActive', msg);
                        this.addMsg(msg.sessionId, [__assign(__assign({}, msg), { status: 'sending' })]);
                        return [4 /*yield*/, this.nim.resendMsg({ msg: msg })];
                    case 1:
                        res = _a.sent();
                        this._handleSendMsgSuccess(res);
                        logger.log('resendMsgActive success', msg);
                        return [2 /*return*/, res];
                    case 2:
                        error_10 = _a.sent();
                        this._handleSendMsgFail(error_10.msg);
                        logger.error('resendMsgActive failed: ', msg, error_10);
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 发送 p2p 消息已读回执
     * @param msg 消息对象
     */
    MsgStore.prototype.sendMsgReceiptActive = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('sendMsgReceiptActive', msg);
                        return [4 /*yield*/, this.nim.sendMsgReceipt({
                                msg: msg,
                            })];
                    case 1:
                        _a.sent();
                        logger.log('sendMsgReceiptActive success', msg);
                        return [3 /*break*/, 3];
                    case 2:
                        error_11 = _a.sent();
                        logger.error('sendMsgReceiptActive failed: ', msg, error_11);
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 发送群组消息已读回执
     * @param options 参考 https://doc.yunxin.163.com/messaging-enhanced/api-refer/web/typedoc/Latest/zh/NIM/modules/MsgServiceInterface.html#teamMsgReceipt-2
     */
    MsgStore.prototype.sendTeamMsgReceiptActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        logger.log('sendTeamMsgReceiptActive', options);
                        if (!options.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.nim.sendTeamMsgReceipt({
                                teamMsgReceipts: options,
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        logger.log('sendTeamMsgReceiptActive success', options);
                        return [3 /*break*/, 4];
                    case 3:
                        error_12 = _a.sent();
                        logger.error('sendTeamMsgReceiptActive failed: ', options, error_12);
                        throw error_12;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 获取群组消息已读未读数
     * @param options 参考 https://doc.yunxin.163.com/messaging-enhanced/api-refer/web/typedoc/Latest/zh/NIM/modules/MsgServiceInterface.html#teamMsgReceipt-2
     */
    MsgStore.prototype.getTeamMsgReadsActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('getTeamMsgReadsActive', options);
                        if (!options.length) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, this.nim.getTeamMsgReads({
                                teamMsgReceipts: options,
                            })];
                    case 1:
                        res = _a.sent();
                        logger.log('getTeamMsgReadsActive success', res);
                        return [2 /*return*/, res];
                    case 2:
                        error_13 = _a.sent();
                        logger.error('getTeamMsgReadsActive failed: ', options, error_13);
                        throw error_13;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 获取历史消息
     * @param options.sessionId - 消息所属的会话的ID
     * @param options.endTime - 结束时间戳, 精确到 ms, 默认为服务器的当前时间
     * @param options.lastMsgId - 上次查询的最后一条消息的 idServer, 第一次不填
     * @param options.limit - 本次查询的消息数量限制, 最多 100 条, 默认 100 条
     */
    MsgStore.prototype.getHistoryMsgActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionId, endTime, lastMsgId, _a, limit, _b, scene, to_1, finalParams, msgs, myMsgs, error_14;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, , 5]);
                        logger.log('getHistoryMsgActive', options);
                        sessionId = options.sessionId, endTime = options.endTime, lastMsgId = options.lastMsgId, _a = options.limit, limit = _a === void 0 ? 100 : _a;
                        _b = parseSessionId(sessionId), scene = _b.scene, to_1 = _b.to;
                        finalParams = {
                            scene: scene,
                            to: to_1,
                            endTime: endTime,
                            limit: limit,
                        };
                        if (lastMsgId) {
                            // 这是因为 sdk 传了 undefined 会请求超时
                            finalParams.lastMsgId = lastMsgId;
                        }
                        return [4 /*yield*/, this.nim.getHistoryMsgs(finalParams)];
                    case 1:
                        msgs = _c.sent();
                        this.addMsg(sessionId, msgs);
                        if (!(scene === 'team' &&
                            this.rootStore.localOptions.teamMsgReceiptVisible)) return [3 /*break*/, 3];
                        myMsgs = msgs
                            .filter(function (item) { return item.from === _this.rootStore.userStore.myUserInfo.account; })
                            .filter(function (item) { return !['notification', 'tip'].includes(item.type); })
                            .map(function (item) { return ({
                            teamId: to_1,
                            idClient: item.idClient,
                            idServer: item.idServer,
                        }); });
                        return [4 /*yield*/, this._handleTeamMsgReadStatus(myMsgs, msgs, sessionId)];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        logger.log('getHistoryMsgActive success', options, finalParams, msgs);
                        return [2 /*return*/, msgs];
                    case 4:
                        error_14 = _c.sent();
                        logger.error('getHistoryMsgActive failed: ', options, error_14);
                        throw error_14;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 转发消息
     * @param options - 转发对象，参考 https://doc.yunxin.163.com/messaging-enhanced/api-refer/web/typedoc/Latest/zh/NIM/modules/src_MsgServiceInterface.html#ForwardMsgOptions
     * @param comment - 留言，可选参数
     */
    MsgStore.prototype.forwardMsgActive = function (options, comment) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var ext, attach_1, finalOptions, res, error_15;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        logger.log('forwardMsgActive', options, comment);
                        ext = options.msg.ext;
                        if (ext) {
                            try {
                                ext = JSON.parse(ext);
                                // @ts-ignore
                                delete ext.yxReplyMsg;
                                // @ts-ignore
                                delete ext.yxAitMsg;
                                ext = JSON.stringify(ext);
                            }
                            catch (error) {
                                //
                            }
                        }
                        attach_1 = __assign({}, options.msg.attach);
                        ['canRecall', 'reCallTimer', 'yxUnread', 'yxRead'].forEach(function (key) {
                            delete attach_1[key];
                        });
                        // IM2 sdk 问题，先组件层删除该字段
                        if (((_a = options.msg.pushInfo) === null || _a === void 0 ? void 0 : _a.pushContent) === '') {
                            delete options.msg.pushInfo.pushContent;
                        }
                        finalOptions = __assign(__assign({}, options), { msg: __assign(__assign({}, options.msg), { ext: ext, attach: attach_1 }) });
                        return [4 /*yield*/, this.nim.forwardMsg(finalOptions)
                            // 转发出去的消息也要能正常撤回
                        ];
                    case 1:
                        res = _b.sent();
                        // 转发出去的消息也要能正常撤回
                        this._handleSendMsgSuccess(res);
                        if (!comment) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.sendTextMsgActive({
                                scene: options.scene,
                                to: options.to,
                                body: comment,
                            })];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        logger.log('forwardMsgActive success', res, comment);
                        return [3 /*break*/, 5];
                    case 4:
                        error_15 = _b.sent();
                        logger.error('forwardMsgActive failed: ', error_15);
                        throw error_15;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * MsgStore添加消息处理函数（MsgStore内部使用，外层不太推荐直接使用）
     * @param sessionId - 消息所属的会话的ID
     * @param msgs- 消息对象数组
     */
    MsgStore.prototype.addMsg = function (sessionId, msgs) {
        var sortFunc = function (a, b) {
            return a.time - b.time;
        };
        var _msgs = this.msgs.get(sessionId) || [];
        msgs
            .filter(function (item) { return !!item.idClient; })
            .forEach(function (item) {
            var _a, _b;
            var _msg = _msgs.find(function (msg) { return msg.idClient === item.idClient; });
            // SDK 可能会返回多条 idClient 相同的数据，此时取 time 最新的
            if (_msg) {
                if (_msg.time <= item.time || _msg.status === 'sending') {
                    var attach = __assign({}, item.attach);
                    // 如果之前的消息有撤回相关字段，则更新时保留
                    if (((_a = _msg.attach) === null || _a === void 0 ? void 0 : _a.canRecall) !== void 0 &&
                        ((_b = _msg.attach) === null || _b === void 0 ? void 0 : _b.reCallTimer) !== void 0) {
                        attach.canRecall = _msg.attach.canRecall;
                        attach.reCallTimer = _msg.attach.reCallTimer;
                    }
                    _msgs.splice(_msgs.indexOf(_msg), 1, __assign(__assign({}, item), { attach: attach }));
                }
            }
            else {
                _msgs.push(item);
            }
        });
        this.msgs.set(sessionId, __spreadArray([], __read(_msgs), false).sort(sortFunc), this.rootStore.uiStore.selectedSession === sessionId);
    };
    /**
     * MsgStore删除消息处理函数（MsgStore内部使用，外层不太推荐直接使用）
     * @param sessionId - 消息所属的会话的ID
     * @param idClients - 端测生成的消息id数组
     */
    MsgStore.prototype.removeMsg = function (sessionId, idClients) {
        var _this = this;
        if (!sessionId) {
            this.getMsg().forEach(function (item) {
                _this._handleClearMsgTimer(item);
            });
            this.msgs.clear();
            return;
        }
        var msgs = this.msgs.get(sessionId);
        if (!msgs) {
            return;
        }
        if (!idClients || !idClients.length) {
            msgs.forEach(function (item) {
                _this._handleClearMsgTimer(item);
            });
            this.msgs.delete(sessionId);
            return;
        }
        this.msgs.set(sessionId, msgs.filter(function (msg) {
            var _a;
            var isDelete = idClients.includes(msg.idClient) &&
                // 无法删除撤回消息
                !(msg.type === 'custom' && ((_a = msg.attach) === null || _a === void 0 ? void 0 : _a.type) === 'beReCallMsg');
            if (isDelete) {
                _this._handleClearMsgTimer(msg);
            }
            return !isDelete;
        }), this.rootStore.uiStore.selectedSession === sessionId);
    };
    /**
     * MsgStore获取消息函数（MsgStore内部使用，外层不太推荐直接使用）
     * @param sessionId - 消息所属的会话的ID
     * @param idClients - 端测生成的消息id数组
     */
    MsgStore.prototype.getMsg = function (sessionId, idClients) {
        if (!sessionId) {
            return this.msgs.values();
        }
        var msgs = this.msgs.get(sessionId) || [];
        if (!idClients || !idClients.length) {
            return msgs;
        }
        // 如果有 idClients，只返回 idClients 中的消息，新数组
        return msgs.filter(function (item) { return idClients.includes(item.idClient); });
    };
    MsgStore.prototype.getMsgByIdServerActive = function (params) {
        return this.nim.getMsgsByIdServer(__assign(__assign({}, params), { reqMsgs: params.reqMsgs.map(function (item) { return (__assign(__assign({}, item), { 
                // 处理下下面几个字段，以兼容其他端可能传来非期望的值
                idServer: item.idServer + '', scene: formatScene(item.scene) })); }) }));
    };
    MsgStore.prototype._handleSendMsgSuccess = function (msg) {
        var _this = this;
        // 两分钟之内可以撤回，记录到消息的 attach 中
        if (msg && msg.sessionId) {
            var canRecallMsg = __assign(__assign({}, msg), { attach: __assign(__assign({}, msg.attach), { canRecall: true, reCallTimer: setTimeout(function () {
                        // 从内存中取最新的，因为中间可能有其他更新
                        var _msg = _this.getMsg(msg.sessionId, [msg.idClient])[0];
                        if (_msg) {
                            var _attach = _msg.attach;
                            if (_attach) {
                                delete _attach.canRecall;
                                delete _attach.reCallTimer;
                            }
                            _msg.attach = _attach;
                            _this.addMsg(msg.sessionId, [_msg]);
                        }
                    }, RECALL_TIME) }) });
            this.addMsg(msg.sessionId, [canRecallMsg]);
        }
    };
    MsgStore.prototype._handleSendMsgFail = function (msg) {
        // 发送失败，拉黑的情况不能撤回、可以删除；网络情况不能撤回、不能删除
        // 因此删除那边做一下 try catch 处理，忽略错误消息
        // 先清除老消息的定时器，再更新消息
        if (msg && msg.sessionId) {
            var oldMsg = this.getMsg(msg.sessionId, [msg.idClient])[0];
            this._handleClearMsgTimer(oldMsg);
            this.addMsg(msg.sessionId, [msg]);
        }
    };
    MsgStore.prototype._handleClearMsgTimer = function (msg) {
        if (msg && msg.attach) {
            clearTimeout(msg.attach.canEditTimer);
            clearTimeout(msg.attach.reCallTimer);
        }
    };
    MsgStore.prototype._onMsg = function (data) {
        logger.log('_onMsg: ', data);
        this.addMsg(data.sessionId, [data]);
    };
    // private _onSyncOfflineMsgs(data: SyncOfflineMsgsResult) {}
    // private _onSyncRoamingMsgs(data: SyncRoamingMsgsResult) {}
    MsgStore.prototype._onTeamMsgReceipts = function (data) {
        var _this = this;
        logger.log('_onTeamMsgReceipts: ', data);
        data.forEach(function (item) {
            var sessionId = "team-".concat(item.teamId);
            var msg = _this.getMsg(sessionId, [item.idClient])[0];
            if (msg) {
                var newMsg = _this._updateReceiptMsg(msg, item);
                _this.addMsg(sessionId, [newMsg]);
            }
        });
    };
    MsgStore.prototype._onDeleteSelfMsgs = function (data) {
        var _this = this;
        logger.log('_onDeleteSelfMsgs: ', data);
        var res = {};
        data.forEach(function (item) {
            var sessionId = _this.rootStore.sessionStore.getSessionId(item.scene, item.from, item.to);
            if (res[sessionId]) {
                res[sessionId].push(item);
            }
            else {
                res[sessionId] = [item];
            }
        });
        Object.keys(res).forEach(function (sessionId) {
            _this.removeMsg(sessionId, res[sessionId].map(function (item) { return item.idClient; }));
        });
    };
    MsgStore.prototype._formatExtField = function (sessionId, ext) {
        var extObj = ext || {};
        // 有回复消息的情况，需要把回复消息的信息放到 ext 中
        var replyMsg = this.replyMsgs.get(sessionId);
        if (replyMsg) {
            extObj.yxReplyMsg = {
                idClient: replyMsg.idClient,
                scene: replyMsg.scene,
                from: replyMsg.from,
                to: replyMsg.to,
                idServer: replyMsg.idServer,
                time: replyMsg.time,
            };
        }
        return Object.keys(extObj).length === 0 ? undefined : JSON.stringify(extObj);
    };
    /*
    private _getExtByReplyMsgs(sessionId: string): string | undefined {
      let ext
      const replyMsg = this.replyMsgs.get(sessionId)
      if (replyMsg) {
        // 记录部分信息，过多ext会导致发送不成功
        // 'type' | 'body' | 'attach' | 'idClient' | 'fromNick' | 'from'
        const yxReplyMsg = {
          sessionId: replyMsg.sessionId,
          fromNick: replyMsg.fromNick,
          flow: replyMsg.flow,
          from: replyMsg.from,
          type: replyMsg.type,
          body: replyMsg.body,
          idClient: replyMsg.idClient,
          idServer: replyMsg.idServer,
        }
        ext = JSON.stringify({
          yxReplyMsg: yxReplyMsg,
        })
      }
      return ext
    }
    */
    MsgStore.prototype._updateReceiptMsg = function (originMsg, data) {
        return __assign(__assign({}, originMsg), { 
            // 在 attach 中存一下，这样不用改 ts 定义
            attach: __assign(__assign({}, originMsg.attach), { yxUnread: Number(data.unread), yxRead: Number(data.read) }) });
    };
    MsgStore.prototype._handleTeamMsgReadStatus = function (params, msgs, sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, newMsgs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        res = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getTeamMsgReadsActive(params)];
                    case 2:
                        res = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        newMsgs = msgs
                            .filter(function (msg) { return res.some(function (status) { return msg.idClient === status.idClient; }); })
                            .map(function (item) {
                            var teamMsgReceipt = res.find(function (j) { return j.idClient === item.idClient; });
                            if (teamMsgReceipt) {
                                return _this._updateReceiptMsg(item, teamMsgReceipt);
                            }
                            return item;
                        });
                        this.addMsg(sessionId, newMsgs);
                        return [2 /*return*/];
                }
            });
        });
    };
    MsgStore.prototype._formatExtAitToPushInfo = function (yxAitMsg, content) {
        function getForcePushIDsList(obj) {
            return Object.keys(obj).includes(AT_ALL_ACCOUNT)
                ? AT_ALL_ACCOUNT_TOSDK
                : JSON.stringify(Object.keys(obj));
        }
        var pushInfo = {
            forcePushIDsList: getForcePushIDsList(yxAitMsg),
            needForcePush: true,
            forcePushContent: content,
        };
        return pushInfo;
    };
    MsgStore.prototype._createUploadMsg = function (_a) {
        var idClient = _a.idClient, scene = _a.scene, to = _a.to, type = _a.type;
        return {
            idClient: idClient,
            flow: 'out',
            from: this.rootStore.userStore.myUserInfo.account,
            to: to,
            sessionId: "".concat(scene, "-").concat(to),
            scene: scene,
            status: 'sending',
            time: Date.now(),
            type: type,
            userUpdateTime: Date.now(),
            target: to,
            body: '',
            feature: 'default',
        };
    };
    return MsgStore;
}());

/**Mobx 可观察对象，负责管理系统消息的子 store */
var SysMsgStore = /** @class */ (function () {
    function SysMsgStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        // 申请消息
        this.applyMsgs = new Map();
        this.unReadSysMsgs = new Map();
        makeAutoObservable(this);
        this._onSysMsg = this._onSysMsg.bind(this);
        this._onUpdateSystemMessages = this._onUpdateSystemMessages.bind(this);
        this._onSyncSysMsgs = this._onSyncSysMsgs.bind(this);
        // 系统通知
        nim.on('sysMsg', this._onSysMsg);
        // 系统消息，主动通过或拒绝好友，本端收到该事件，多端同步走 syncFriend
        nim.on('updateSystemMessages', this._onUpdateSystemMessages);
        // 同步时系统消息
        nim.on('syncSysMsgs', this._onSyncSysMsgs);
    }
    /**
     * SysMsgStore增加申请消息处理函数（SysMsgStore内部使用，外层不太推荐直接使用）
     * @param msg 系统消息对象
     */
    SysMsgStore.prototype.addApplyMsg = function (msg) {
        if (msg.from && msg.type && msg.to) {
            // TODO SDK 有部分系统通知没有 idServer，因此先用 from 和 type 做 key，等后续 sdk 升级
            var id = "".concat(msg.from, "-").concat(msg.type, "-").concat(msg.to);
            this.unReadSysMsgs.set(id, msg);
            this.applyMsgs.set(id, msg);
        }
        else {
            logger.warn('addApplyMsg drop', msg);
            return;
        }
    };
    /**
     * SysMsgStore删除申请消息处理函数（SysMsgStore内部使用，外层不太推荐直接使用）
     * @param idServer 服务器用于区分消息用的ID
     */
    SysMsgStore.prototype.deleteApplyMsg = function (msg) {
        if (msg.from && msg.type && msg.to) {
            var id = "".concat(msg.from, "-").concat(msg.type, "-").concat(msg.to);
            this.applyMsgs.delete(id);
            this.unReadSysMsgs.delete(id);
        }
        else {
            logger.warn('deleteApplyMsg drop', msg);
            return;
        }
    };
    // TODO 这里 sdk 没有返回 idServer，因此只能根据 from 和 type 来更新，等待 sdk 优化
    // IM1 在同意好友申请和拒绝好友申请时，这个回调里什么都没有，因此还需要手动处理
    /**
     * SysMsgStore更新申请消息处理函数（SysMsgStore内部使用，外层不太推荐直接使用）
     */
    SysMsgStore.prototype.updateApplyMsg = function (_a) {
        var idServer = _a.idServer, from = _a.from, state = _a.state, type = _a.type, to = _a.to;
        var id = '';
        if (from && type && to) {
            id = "".concat(from, "-").concat(type, "-").concat(to);
        }
        else {
            logger.warn('updateApplyMsg drop', {
                idServer: idServer,
                from: from,
                state: state,
                type: type,
            });
            return;
        }
        var oldSysMsg = this.applyMsgs.get(id);
        if (oldSysMsg) {
            this.applyMsgs.set(id, __assign(__assign({}, oldSysMsg), { from: from, type: type, state: state }));
        }
        // 这里还要继续响应一些操作
        switch (type) {
            case 'friendRequest':
                if (state === 'pass') {
                    this.rootStore.friendStore.addFriend([
                        {
                            account: from,
                            updateTime: Date.now(),
                            createTime: Date.now(),
                            valid: true,
                        },
                    ]);
                }
                break;
        }
    };
    Object.defineProperty(SysMsgStore.prototype, "unreadSysMsgCount", {
        /**
         * 获取去重后的未读系统消息
         */
        get: function () {
            return __spreadArray([], __read(this.unReadSysMsgs.keys()), false).length;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 删除未读系统消息
     */
    SysMsgStore.prototype.deleteUnReadSysMsgs = function (type, from, to) {
        var id = "".concat(from, "-").concat(type, "-").concat(to);
        this.unReadSysMsgs.delete(id);
    };
    /**
     * 重置系统消息未读
     */
    SysMsgStore.prototype.resetSystemMsgUnread = function () {
        this.unReadSysMsgs.clear();
    };
    /**
     * 销毁SysMsgStore，会取消系统消息事件监听
     */
    SysMsgStore.prototype.destroy = function () {
        this.nim.off('sysMsg', this._onSysMsg);
        this.nim.off('updateSystemMessages', this._onUpdateSystemMessages);
        this.nim.off('syncSysMsgs', this._onSyncSysMsgs);
    };
    SysMsgStore.prototype._handleBeRecallMsg = function (msg, scene) {
        if (!msg.recallMessageInfo) {
            return;
        }
        var from = msg.from, to = msg.to, time = msg.time;
        var _a = msg.recallMessageInfo, idClient = _a.idClient, opeAccount = _a.opeAccount;
        var fromAccount = opeAccount || from;
        this.rootStore.msgStore.beReCallMsgActive({
            scene: scene,
            from: fromAccount,
            to: to,
            idClient: idClient,
            time: time,
        });
    };
    SysMsgStore.prototype._handleAddFriend = function (msg) {
        var from = msg.from, time = msg.time;
        // TODO 这边先由端上构造一条 FriendProfile，实际该由 SDK 提供
        var friend = {
            account: from,
            updateTime: time,
            createTime: time,
            valid: true,
            relationShip: 1,
            passRelationShip: 1,
        };
        this.rootStore.friendStore.addFriend([friend]);
    };
    SysMsgStore.prototype._handleSysMsg = function (msg) {
        var _a;
        switch (msg.type) {
            // 申请加入超级群
            case 'applySuperTeam':
                // this.addApplyMsg(msg)
                break;
            // 申请加入群
            case 'applyTeam':
                this.addApplyMsg(msg);
                break;
            // 自定义点对点系统通知
            case 'customP2p':
                break;
            // // 自定义超级群系统通知
            case 'customSuperTeam':
                break;
            // 自定义群系统通知
            case 'customTeam':
                break;
            // 删除好友
            case 'deleteFriend':
                this.rootStore.friendStore.removeFriend([msg.from]);
                break;
            // 单向删除点对点消息
            case 'deleteMsgP2pOneWay':
                break;
            // 单向删除群消息
            case 'deleteMsgTeamOneWay':
                break;
            // 好友申请
            case 'friendRequest': {
                switch ((_a = msg.attach) === null || _a === void 0 ? void 0 : _a.type) {
                    // 添加好友
                    case 'addFriend':
                        this._handleAddFriend(msg);
                        break;
                    // 申请加为好友
                    case 'applyFriend':
                        this.addApplyMsg(msg);
                        break;
                    // 好友申请通过
                    case 'passFriendApply':
                        this._handleAddFriend(msg);
                        this.addApplyMsg(msg);
                        break;
                    // 拒绝好友申请
                    case 'rejectFriendApply':
                        this.addApplyMsg(msg);
                        break;
                }
                break;
            }
            // 撤回点对点消息（被动）
            case 'recallMsgP2p':
                this._handleBeRecallMsg(msg, 'p2p');
                break;
            // 撤回超级群消息（被动）
            case 'recallMsgSuperTeam':
                this._handleBeRecallMsg(msg, 'superTeam');
                break;
            // 撤回群消息（被动）
            case 'recallMsgTeam':
                this._handleBeRecallMsg(msg, 'team');
                break;
            // 相关 (管理员)拒绝申请入超级群
            case 'rejectSuperTeamApply':
                // this.addApplyMsg(msg)
                break;
            // 相关 (某人)拒绝邀请
            case 'rejectSuperTeamInvite':
                // this.addApplyMsg(msg)
                break;
            // 相关 (管理员)拒绝申请入群
            case 'rejectTeamApply':
                this.addApplyMsg(msg);
                break;
            // 相关 (某人)拒绝邀请
            case 'rejectTeamInvite':
                this.addApplyMsg(msg);
                break;
            // 相关 (管理员)邀请某人
            case 'superTeamInvite':
                break;
            // 相关 (管理员)邀请某人
            case 'teamInvite':
                this.addApplyMsg(msg);
                break;
        }
    };
    // private _handleUnreadSysMsgKey(type: string, from: string, to?: string) {
    //   let id = ''
    //   //因为群相关系统消息无法通过from和type来确定系统消息唯一性，所以根据type区分，群消息key中增加to
    //   if (type === 'friendRequest') {
    //     id = `${from}-${type}`
    //   } else {
    //     id = `${from}-${type}-${to}`
    //   }
    //   return id
    // }
    SysMsgStore.prototype._onSysMsg = function (data) {
        logger.log('_onSysMsg: ', data);
        this._handleSysMsg(data);
    };
    SysMsgStore.prototype._onUpdateSystemMessages = function (data) {
        var _this = this;
        logger.log('_onUpdateSystemMessages: ', data);
        data.forEach(function (item) {
            _this.updateApplyMsg(__assign(__assign({}, item), { to: _this.rootStore.userStore.myUserInfo.account }));
        });
    };
    SysMsgStore.prototype._onSyncSysMsgs = function (data) {
        var _this = this;
        logger.log('_onSyncSysMsgs: ', data);
        data
            .sort(function (a, b) { return a.time - b.time; })
            .forEach(function (item) {
            _this._handleSysMsg(item);
        });
    };
    return SysMsgStore;
}());

/**Mobx 可观察对象，负责管理黑名单和静音列表的子store */
var RelationStore = /** @class */ (function () {
    function RelationStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.blacklist = [];
        this.mutes = [];
        makeAutoObservable(this);
        this._onRelations = this._onRelations.bind(this);
        this._onUpdateBlackList = this._onUpdateBlackList.bind(this);
        this._onUpdateMuteList = this._onUpdateMuteList.bind(this);
        // 黑名单和静音列表
        nim.on('relations', this._onRelations);
        // 黑名单更新
        nim.on('updateBlackList', this._onUpdateBlackList);
        // 静音列表更新
        nim.on('updateMuteList', this._onUpdateMuteList);
    }
    /**
     * 销毁RelationStore，会取消相关事件监听
     */
    RelationStore.prototype.destroy = function () {
        this.nim.off('relations', this._onRelations);
        this.nim.off('updateBlackList', this._onUpdateBlackList);
        this.nim.off('updateMuteList', this._onUpdateMuteList);
    };
    /**
     * RelationStore加入黑名单列表的处理函数（RelationStore内部使用，外层不太推荐直接使用）
     * @param accounts - 账号数组
     */
    RelationStore.prototype.addBlacklist = function (accounts) {
        this.blacklist = __spreadArray([], __read(new Set(this.blacklist.concat(accounts))), false);
    };
    /**
     * RelationStore移除黑名单列表的处理函数（RelationStore内部使用，外层不太推荐直接使用）
     * @param accounts - 账号数组
     */
    RelationStore.prototype.removeBlacklist = function (accounts) {
        this.blacklist = this.blacklist.filter(function (i) {
            return accounts.every(function (j) { return i !== j; });
        });
    };
    /**
     * 是否在黑名单列表
     */
    RelationStore.prototype.isInBlacklist = function (account) {
        return this.blacklist.includes(account);
    };
    /**
     * RelationStore加入静音列表的处理函数（RelationStore内部使用，外层不太推荐直接使用）
     * @param accounts - 账号数组
     */
    RelationStore.prototype.addMutes = function (accounts) {
        this.mutes = __spreadArray([], __read(new Set(this.mutes.concat(accounts))), false);
    };
    /**
     * RelationStore移除静音列表的处理函数（RelationStore内部使用，外层不太推荐直接使用）
     * @param accounts - 账号数组
     */
    RelationStore.prototype.removeMutes = function (accounts) {
        this.mutes = this.mutes.filter(function (i) { return accounts.every(function (j) { return i !== j; }); });
    };
    /**
     * 加入/移除 黑名单
     * @param account 账号
     * @param isAdd  isAdd 为 true 时, 会将 account 设置（黑名单，静音） 如果一个用户被加入了黑名单, 那么就不再会收到此用户发送的消息。isAdd 为 false 时, 会将 account 取消设置 如果一个用户被从黑名单移除, 那么可以收到此用户发送的消息
     */
    RelationStore.prototype.setBlackActive = function (_a) {
        var account = _a.account, isAdd = _a.isAdd;
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        logger.log('setBlackActive', { account: account, isAdd: isAdd });
                        return [4 /*yield*/, this.nim.setBlack({ account: account, isAdd: isAdd })];
                    case 1:
                        _b.sent();
                        if (isAdd) {
                            this.addBlacklist([account]);
                        }
                        else {
                            this.removeBlacklist([account]);
                        }
                        logger.log('setBlackActive success', { account: account, isAdd: isAdd });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        logger.error('setBlackActive failed: ', { account: account, isAdd: isAdd }, error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 加入/移除 静音列表
     * @param account 账号
     * @param isAdd  isAdd 为 true 时, 会将 account 设置静音， isAdd 为 false 时, 会将 account 取消设置
     */
    RelationStore.prototype.setMuteActive = function (_a) {
        var account = _a.account, isAdd = _a.isAdd;
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        logger.log('setMuteActive', { account: account, isAdd: isAdd });
                        return [4 /*yield*/, this.nim.setMute({ account: account, isAdd: isAdd })];
                    case 1:
                        _b.sent();
                        if (isAdd) {
                            this.addMutes([account]);
                        }
                        else {
                            this.removeMutes([account]);
                        }
                        logger.log('setMuteActive success', { account: account, isAdd: isAdd });
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        logger.error('setMuteActive failed: ', { account: account, isAdd: isAdd }, error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RelationStore.prototype._onRelations = function (data) {
        logger.log('_onRelations: ', data);
        this.addBlacklist(data.blackList.map(function (item) { return item.account; }));
        this.addMutes(data.muteList.map(function (item) { return item.account; }));
    };
    RelationStore.prototype._onUpdateBlackList = function (data) {
        logger.log('_onUpdateBlackList: ', data);
        if (data.isAdd) {
            this.addBlacklist([data.account]);
        }
        else {
            this.removeBlacklist([data.account]);
        }
    };
    RelationStore.prototype._onUpdateMuteList = function (data) {
        logger.log('_onUpdateMuteList: ', data);
        if (data.isAdd) {
            this.addMutes([data.account]);
        }
        else {
            this.removeMutes([data.account]);
        }
    };
    return RelationStore;
}());

/**Mobx 可观察对象，负责管理会话列表的子 store */
var SessionStore = /** @class */ (function () {
    function SessionStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.sessions = new Map();
        makeAutoObservable(this);
        this._onSessions = this._onSessions.bind(this);
        this._onUpdateSession = this._onUpdateSession.bind(this);
        // 会话信息
        nim.on('sessions', this._onSessions);
        // 会话更新
        nim.on('updateSession', this._onUpdateSession);
    }
    /**
     * 销毁SessionStore，会取消会话相关事件监听
     */
    SessionStore.prototype.destroy = function () {
        this.nim.off('sessions', this._onSessions);
        this.nim.off('updateSession', this._onUpdateSession);
    };
    /**
     * SessionStore添加会话处理函数（SessionStore内部使用，外层不太推荐直接使用）
     * @param sessions - 消息所属的会话的ID数组
     */
    SessionStore.prototype.addSession = function (sessions) {
        var _this = this;
        // 暂时不支持 superTeam
        sessions
            .filter(function (item) { return !!item.id; })
            // addSession时过滤掉 lastMsg 为空的情况
            .filter(function (item) { return item.lastMsg !== void 0; })
            // elite sdk v0.15.0 把置顶消息给开放出来了，先根据 updateTime 过滤掉
            // .filter(
            //   (item) =>
            //     !(item.lastMsg === null && !item.updateTime && !!item.stickTopInfo)
            // )
            // 过滤掉自己被移除群聊或者解散群聊的会话，防止因为时序问题导致的会话未被删除的问题。fix http://jira.netease.com/browse/AUTO-38543。
            .filter(function (item) {
            var _a, _b, _c, _d, _e, _f, _g;
            if (((_b = (_a = item.lastMsg) === null || _a === void 0 ? void 0 : _a.attach) === null || _b === void 0 ? void 0 : _b.type) === 'dismissTeam') {
                return false;
            }
            if (((_d = (_c = item.lastMsg) === null || _c === void 0 ? void 0 : _c.attach) === null || _d === void 0 ? void 0 : _d.type) === 'removeTeamMembers' &&
                (((_f = (_e = item.lastMsg) === null || _e === void 0 ? void 0 : _e.attach) === null || _f === void 0 ? void 0 : _f.accounts) || []).includes((_g = _this.rootStore.userStore.myUserInfo) === null || _g === void 0 ? void 0 : _g.account)) {
                return false;
            }
            return true;
        })
            .filter(function (item) { return item.scene !== 'superTeam'; })
            .map(function (item) { return __awaiter(_this, void 0, void 0, function () {
            var oldSession, newSession;
            var _this = this;
            return __generator(this, function (_a) {
                oldSession = this.sessions.get(item.id);
                newSession = __assign({}, item);
                this.sessions.set(newSession.id, newSession);
                // 判断是否需要展示@消息
                this._needShowBeMentioned(newSession, oldSession).then(function (needShowBeMentioned) {
                    if (_this.sessions.has(newSession.id)) {
                        var _newSession = _this.sessions.get(item.id);
                        _newSession[BE_MENTIONED] = needShowBeMentioned;
                        _this.sessions.set(newSession.id, _newSession);
                    }
                });
                return [2 /*return*/];
            });
        }); });
    };
    /**
     * SessionStore更新会话处理函数（SessionStore内部使用，外层不太推荐直接使用）
     * @param sessions - 消息所属的会话的ID数组
     */
    // 更新时不过滤 lastMsg 为空的情况，因为在 add 时已经过滤过一次了，理论上除了本地临时会话，都是有 lastMsg 的
    SessionStore.prototype.updateSession = function (sessions) {
        var _this = this;
        // 暂时不支持 superTeam
        sessions
            .filter(function (item) { return !!item.id; })
            .filter(function (item) { return item.scene !== 'superTeam'; })
            .forEach(function (item) {
            var oldSession = _this.sessions.get(item.id);
            _this.sessions.set(item.id, __assign(__assign({}, oldSession), item));
        });
    };
    /**
     * SessionStore移除会话处理函数（SessionStore内部使用，外层不太推荐直接使用）
     * @param sessionIds - 消息所属的会话的ID数组
     */
    SessionStore.prototype.removeSession = function (sessionIds) {
        var _this = this;
        sessionIds.forEach(function (item) {
            _this.sessions.delete(item);
            if (_this.rootStore.uiStore.selectedSession === item) {
                _this.rootStore.uiStore.unselectSession();
            }
        });
    };
    /**
     * SessionStore获取会话ID函数（SessionStore内部使用，外层不太推荐直接使用）
     * @param sessions - 消息所属的会话的ID数组
     * @param scene - 场景
     * @param from - 发送方
     * @param to - 接收方, 对方帐号或者群id
     */
    SessionStore.prototype.getSessionId = function (scene, from, to) {
        var _a;
        var myAccount = (_a = this.rootStore.userStore.myUserInfo) === null || _a === void 0 ? void 0 : _a.account;
        // 在（超级）群中，不管 from 是不是自己，sessionId 都要取 to
        var target = '';
        if (scene === 'p2p') {
            if (from === myAccount) {
                target = to;
            }
            else {
                target = from;
            }
        }
        else {
            target = to;
        }
        var sessionId = "".concat(scene, "-").concat(target);
        return sessionId;
    };
    /**
     * SessionStore重置会话函数（SessionStore内部使用，外层不太推荐直接使用）
     * @param sessionId - 消息所属的会话的ID
     */
    SessionStore.prototype.resetSession = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var session, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.log('resetSession', sessionId);
                        session = this.sessions.get(sessionId);
                        if (!session) {
                            logger.warn('resetSession: session is not found.', sessionId);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!session.unread) return [3 /*break*/, 3];
                        // 请求前也清理一次会话未读数，fix http://jira.netease.com/browse/YYTX-34326
                        this._resetMemorySessionUnreadCount(session);
                        return [4 /*yield*/, this.nim.resetSessionUnreadCount({
                                id: session.id,
                            })];
                    case 2:
                        _a.sent();
                        this._resetMemorySessionUnreadCount(session);
                        _a.label = 3;
                    case 3:
                        logger.log('resetSession success');
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        logger.error('resetSession failed: ', error_1);
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 插入一条会话记录
     * @param scene - 场景
     * @param to - 接收方, 对方帐号或者群id
     * @param isSelected - 是否选中
     */
    SessionStore.prototype.insertSessionActive = function (scene, to, isSelected) {
        if (isSelected === void 0) { isSelected = true; }
        return __awaiter(this, void 0, void 0, function () {
            var sessionId, _t, tempSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.log('insertSessionActive', { scene: scene, to: to, isSelected: isSelected });
                        sessionId = "".concat(scene, "-").concat(to);
                        if (!this.sessions.has(sessionId)) {
                            _t = this._genTempSession(scene, to);
                            tempSession = __assign(__assign({}, _t), { 
                                // 这里统一给 tempSession 加上 lastMsg
                                lastMsg: _t.lastMsg || {} });
                            this.addSession([tempSession]);
                        }
                        if (!isSelected) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.rootStore.uiStore.selectSession(sessionId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 删除会话记录
     * @param sessionId - 消息所属的会话的ID
     */
    SessionStore.prototype.deleteSessionActive = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        logger.log('deleteSessionActive', sessionId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.deleteStickTopSessionActive(sessionId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, this.nim.deleteSession({
                            id: sessionId,
                            isSyncToServer: true,
                        })];
                    case 5:
                        _a.sent();
                        this.removeSession([sessionId]);
                        logger.log('deleteSessionActive success');
                        return [3 /*break*/, 7];
                    case 6:
                        error_3 = _a.sent();
                        logger.error('deleteSessionActive failed: ', error_3);
                        throw error_3;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 新增会话置顶
     * @param sessionId - 消息所属的会话的ID
     */
    SessionStore.prototype.addStickTopSessionActive = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('addStickTopSessionActive', sessionId);
                        return [4 /*yield*/, this.nim.addStickTopSession({
                                id: sessionId,
                            })];
                    case 1:
                        res = _a.sent();
                        this.updateSession([__assign(__assign({}, res), { updateTime: Date.now() })]);
                        logger.log('addStickTopSessionActive success');
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        logger.error('addStickTopSessionActive failed: ', error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 删除置顶会话
     * @param sessionId - 消息所属的会话的ID
     */
    SessionStore.prototype.deleteStickTopSessionActive = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('deleteStickTopSessionActive', sessionId);
                        return [4 /*yield*/, this.nim.deleteStickTopSession({
                                id: sessionId,
                            })
                            // 因为临时会话返回的 updateTime 为0，因此这边处理一下
                        ];
                    case 1:
                        res = _a.sent();
                        // 因为临时会话返回的 updateTime 为0，因此这边处理一下
                        this.updateSession([__assign(__assign({}, res), { updateTime: Date.now() })]);
                        logger.log('deleteStickTopSessionActive success');
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        logger.error('deleteStickTopSessionActive failed: ', error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SessionStore.prototype._resetMemorySessionUnreadCount = function (session) {
        var newSession = __assign(__assign({}, session), { unread: 0, unreadMsgs: [] });
        this.addSession([newSession]);
    };
    SessionStore.prototype._onSessions = function (data) {
        logger.log('_onSessions: ', data);
        this.addSession(data);
    };
    SessionStore.prototype._onUpdateSession = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.log('_onUpdateSession: ', data);
                        this.addSession([data]);
                        if (!(this.rootStore.uiStore.selectedSession === data.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.resetSession(data.id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SessionStore.prototype._genTempSession = function (scene, to) {
        var tempSession = {
            id: "".concat(scene, "-").concat(to),
            scene: scene,
            to: to,
            unread: 0,
            updateTime: Date.now(),
        };
        return tempSession;
    };
    /**
     * 会话是否需要展示被@
     */
    SessionStore.prototype._needShowBeMentioned = function (newSession, oldSession) {
        return __awaiter(this, void 0, void 0, function () {
            var unreadMsgs, unreadMsgs, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(newSession.id !== this.rootStore.uiStore.selectedSession)) return [3 /*break*/, 2];
                        // 无新的消息，但是旧会话未读消息中有@消息，直接展示被@，不去拉消息历史记录
                        if ((newSession === null || newSession === void 0 ? void 0 : newSession.unread) > 0 &&
                            (oldSession === null || oldSession === void 0 ? void 0 : oldSession.unread) > 0 &&
                            (newSession === null || newSession === void 0 ? void 0 : newSession.unread) === (oldSession === null || oldSession === void 0 ? void 0 : oldSession.unread) &&
                            this.rootStore.localOptions.needMention &&
                            newSession.scene === 'team' &&
                            oldSession[BE_MENTIONED]) {
                            return [2 /*return*/, true];
                        }
                        // 已经加载完会话了，并且该会话之前的未读消息中有@消息，此时该会话中又收到了新消息，直接展示被@, 不去拉消息历史记录
                        if ((newSession === null || newSession === void 0 ? void 0 : newSession.unread) > 0 &&
                            (oldSession === null || oldSession === void 0 ? void 0 : oldSession.unread) > 0 &&
                            (newSession === null || newSession === void 0 ? void 0 : newSession.unread) > (oldSession === null || oldSession === void 0 ? void 0 : oldSession.unread) &&
                            this.rootStore.localOptions.needMention &&
                            newSession.scene === 'team' &&
                            oldSession[BE_MENTIONED]) {
                            return [2 /*return*/, true];
                        }
                        // 已经加载完会话了，并且该会话之前的未读消息中没有@消息，此时该会话中又收到了新消息，根据lastMsg判断是否展示被@, 不去拉消息历史记录
                        if ((newSession === null || newSession === void 0 ? void 0 : newSession.unread) > 0 &&
                            (oldSession === null || oldSession === void 0 ? void 0 : oldSession.unread) > 0 &&
                            (newSession === null || newSession === void 0 ? void 0 : newSession.unread) > (oldSession === null || oldSession === void 0 ? void 0 : oldSession.unread) &&
                            this.rootStore.localOptions.needMention &&
                            newSession.scene === 'team') {
                            unreadMsgs = [newSession.lastMsg];
                            return [2 /*return*/, this._isAtMsg(unreadMsgs)];
                        }
                        if (!
                        // 首次加载时，oldSession为空,unread 值默认给0
                        ((newSession === null || newSession === void 0 ? void 0 : newSession.unread) > ((oldSession === null || oldSession === void 0 ? void 0 : oldSession.unread) || 0) &&
                            this.rootStore.localOptions.needMention &&
                            newSession.scene === 'team' &&
                            (newSession === null || newSession === void 0 ? void 0 : newSession.unread) > 0)) 
                        // 首次加载时，oldSession为空,unread 值默认给0
                        return [3 /*break*/, 2];
                        unreadMsgs = [newSession.lastMsg];
                        // 如果最新一条消息是@消息，直接展示被@，不用去拉历史记录
                        if (this._isAtMsg(unreadMsgs)) {
                            return [2 /*return*/, true];
                        }
                        if (!(newSession.unread > 1 && newSession.lastMsg)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.rootStore.msgStore.getHistoryMsgActive({
                                sessionId: newSession.id,
                                endTime: newSession.lastMsg.time,
                                lastMsgId: newSession.lastMsg.idServer,
                                limit: newSession.unread - 1,
                            })];
                    case 1:
                        res = _a.sent();
                        unreadMsgs = __spreadArray([], __read(res), false);
                        return [2 /*return*/, this._isAtMsg(unreadMsgs)];
                    case 2: return [2 /*return*/, false];
                }
            });
        });
    };
    SessionStore.prototype._isAtMsg = function (msgs) {
        var _this = this;
        var flag = false;
        msgs.forEach(function (msg) {
            if (msg === null || msg === void 0 ? void 0 : msg.ext) {
                try {
                    var extObj = JSON.parse(msg.ext);
                    var yxAitMsg = extObj.yxAitMsg;
                    var account_1 = _this.rootStore.userStore.myUserInfo.account;
                    if (yxAitMsg) {
                        Object.keys(yxAitMsg).forEach(function (key) {
                            if (key === account_1 || key === AT_ALL_ACCOUNT) {
                                flag = true;
                            }
                        });
                    }
                }
                catch (_a) { }
            }
        });
        return flag;
    };
    return SessionStore;
}());

/**Mobx 可观察对象，负责管理群组的子 store */
var TeamStore = /** @class */ (function () {
    function TeamStore(rootStore, nim, localOptions) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.localOptions = localOptions;
        this.teams = new Map();
        makeAutoObservable(this);
        this._onCreateTeam = this._onCreateTeam.bind(this);
        this._onDismissTeam = this._onDismissTeam.bind(this);
        this._onUpdateTeam = this._onUpdateTeam.bind(this);
        this._onTeams = this._onTeams.bind(this);
        this._onTransferTeam = this._onTransferTeam.bind(this);
        // 多端同步创建群
        nim.on('createTeam', this._onCreateTeam);
        // 群解散
        nim.on('dismissTeam', this._onDismissTeam);
        // 群更新
        nim.on('updateTeam', this._onUpdateTeam);
        // 群信息
        nim.on('teams', this._onTeams);
        // 群转让
        nim.on('transferTeam', this._onTransferTeam);
    }
    /**
     * 销毁TeamStore，会取消群组相关事件监听
     */
    TeamStore.prototype.destroy = function () {
        this.nim.off('createTeam', this._onCreateTeam);
        this.nim.off('dismissTeam', this._onDismissTeam);
        this.nim.off('updateTeam', this._onUpdateTeam);
        this.nim.off('teams', this._onTeams);
        this.nim.off('transferTeam', this._onTransferTeam);
    };
    /**
     * TeamStore增加群组（TeamStore内部使用，外层不太推荐直接使用）
     * @param teams - 群组
     */
    TeamStore.prototype.addTeam = function (teams) {
        var _this = this;
        teams
            .filter(function (item) { return !!item.valid; })
            .filter(function (item) { return !!item.teamId; })
            .forEach(function (item) {
            _this.teams.set(item.teamId, item);
        });
    };
    /**
     * TeamStore移除群组（TeamStore内部使用，外层不太推荐直接使用）
     * @param teamIds - 群id数组
     */
    TeamStore.prototype.removeTeam = function (teamIds) {
        var _this = this;
        teamIds.forEach(function (item) {
            _this.teams.delete(item);
        });
    };
    /**
     * TeamStore更新群组（TeamStore内部使用，外层不太推荐直接使用）
     * @param data - 群组信息
     */
    TeamStore.prototype.updateTeam = function (data) {
        var _this = this;
        data
            .filter(function (item) { return !!item.teamId; })
            .forEach(function (item) {
            var oldTeam = _this.teams.get(item.teamId);
            if (oldTeam) {
                var newTeam = __assign(__assign({}, oldTeam), item);
                _this.teams.set(item.teamId, newTeam);
            }
        });
    };
    /**
     * 创建群
     * @param __namedParameters.accounts - 要拉进群的成员的帐号列表
     * @param __namedParameters.avatar - 群头像
     * @param __namedParameters.name - 群名称
     * @param __namedParameters.intro - 群简介
     * @param __namedParameters.ext - 群扩展字段
     */
    TeamStore.prototype.createTeamActive = function (_a) {
        var accounts = _a.accounts, avatar = _a.avatar, name = _a.name, intro = _a.intro, ext = _a.ext;
        return __awaiter(this, void 0, void 0, function () {
            var team, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        logger.log('createTeamActive', {
                            accounts: accounts,
                            avatar: avatar,
                            name: name,
                        });
                        return [4 /*yield*/, this.nim.createTeam({
                                accounts: accounts,
                                avatar: avatar,
                                type: 'advanced',
                                joinMode: this.localOptions.teamJoinMode,
                                beInviteMode: this.localOptions.teamBeInviteMode,
                                inviteMode: this.localOptions.teamInviteMode,
                                updateTeamMode: this.localOptions.teamUpdateTeamMode,
                                updateExtMode: this.localOptions.teamUpdateExtMode,
                                name: name,
                                intro: intro || 'no content',
                                ext: ext,
                            })];
                    case 1:
                        team = _b.sent();
                        return [4 /*yield*/, this._handleAddTeam(team)
                            // 会收到一条 onAddTeamMember 事件
                        ];
                    case 2:
                        _b.sent();
                        // 会收到一条 onAddTeamMember 事件
                        logger.log('createTeamActive success', { accounts: accounts, avatar: avatar, name: name });
                        return [2 /*return*/, team];
                    case 3:
                        error_1 = _b.sent();
                        logger.error('createTeamActive failed: ', { accounts: accounts, avatar: avatar, name: name }, error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 申请入群
     * @param teamId - 群id
     */
    TeamStore.prototype.applyTeamActive = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('applyTeamActive', teamId);
                        return [4 /*yield*/, this.nim.applyTeam({ teamId: teamId })
                            // 这边不再直接维护群信息，因为要兼容申请入群的情况，放到 onAddTeamMembers 中处理
                            // await this._handleAddTeam(team)
                        ];
                    case 1:
                        _a.sent();
                        // 这边不再直接维护群信息，因为要兼容申请入群的情况，放到 onAddTeamMembers 中处理
                        // await this._handleAddTeam(team)
                        logger.log('applyTeamActive success', teamId);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        logger.error('applyTeamActive failed: ', teamId, error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 主动退群
     * @param teamId - 群id
     */
    TeamStore.prototype.leaveTeamActive = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('leaveTeamActive', teamId);
                        return [4 /*yield*/, this.nim.leaveTeam({ teamId: teamId })
                            // 会收到一条 onRemoveTeamMember 事件
                            // await this._handleRemoveTeam(teamId)
                        ];
                    case 1:
                        _a.sent();
                        // 会收到一条 onRemoveTeamMember 事件
                        // await this._handleRemoveTeam(teamId)
                        logger.log('leaveTeamActive success', teamId);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        logger.error('leaveTeamActive failed: ', teamId, error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 解散群
     * @param teamId - 群id
     */
    TeamStore.prototype.dismissTeamActive = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('dismissTeamActive', teamId);
                        return [4 /*yield*/, this.nim.dismissTeam({ teamId: teamId })
                            // 会收到一条 onDissmiss 事件
                            // await this._handleRemoveTeam(teamId)
                        ];
                    case 1:
                        _a.sent();
                        // 会收到一条 onDissmiss 事件
                        // await this._handleRemoveTeam(teamId)
                        logger.log('dismissTeamActive success', teamId);
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        logger.error('dismissTeamActive failed: ', teamId, error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 转让群主
     * @param teamId - 群id;
     * @param account - 账号;
     */
    TeamStore.prototype.transferTeamActive = function (_a) {
        var teamId = _a.teamId, account = _a.account, leave = _a.leave;
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        logger.log('transferTeamActive', { teamId: teamId, account: account, leave: leave });
                        return [4 /*yield*/, this.nim.transferTeam({
                                teamId: teamId,
                                account: account,
                                leave: leave !== null && leave !== void 0 ? leave : this.localOptions.leaveOnTransfer,
                            })];
                    case 1:
                        _b.sent();
                        logger.log('transferTeamActive success', { teamId: teamId, account: account, leave: leave });
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _b.sent();
                        logger.error('transferTeamActive failed: ', { teamId: teamId, account: account, leave: leave }, error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 群禁言
     * @param options
     * options.teamId - 群id <br>
     * options.mute - 是否禁言
     */
    TeamStore.prototype.muteTeamActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('muteTeamActive', options);
                        return [4 /*yield*/, this.nim.muteTeam(options)];
                    case 1:
                        _a.sent();
                        logger.log('muteTeamActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        logger.error('muteTeamActive failed: ', options, error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // 群消息免打扰
    // async quietsTeamActive(): Promise<void> {
    // }
    /**
     * 更新群
     * @param options
     * options.teamId - 群id <br>
     * options.name - 群名称  <br>
     * options.avatar - 群头像 <br>
     * options.announcement  - 群公告 <br>
     * options.joinMode - 群加入方式 <br>
     * options.beInviteMode	 - 群被邀请模式 <br>
     * options.inviteMode - 群邀请模式 <br>
     * options.updateTeamMode - 群信息修改权限 <br>
     * options.updateExtMode - manager | all <br>
     */
    TeamStore.prototype.updateTeamActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('updateTeamActive', options);
                        return [4 /*yield*/, this.nim.updateTeamInfo(options)
                            // 后续在事件中处理
                        ];
                    case 1:
                        _a.sent();
                        // 后续在事件中处理
                        logger.log('updateTeamActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_7 = _a.sent();
                        logger.error('updateTeamActive failed: ', options, error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 获取群信息
     * @param teamId - 群id
     */
    TeamStore.prototype.getTeamActive = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var team;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.log('getTeamActive: ', teamId);
                        team = this.teams.get(teamId);
                        if (team) {
                            return [2 /*return*/, team];
                        }
                        return [4 /*yield*/, this.getTeamForceActive(teamId)];
                    case 1:
                        team = _a.sent();
                        this.addTeam([team]);
                        return [2 /*return*/, team];
                }
            });
        });
    };
    /**
     * 获取群信息（搜索时使用）
     * @param teamId - 群id
     */
    TeamStore.prototype.getTeamForceActive = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('getTeamForceActive: ', teamId);
                        return [4 /*yield*/, this.nim.getTeamInfo({ teamId: teamId })];
                    case 1:
                        res = _a.sent();
                        logger.log('getTeamForceActive success', res);
                        // 这里不能存入 teamStore，因为 teamStore 只有在群中的内容
                        return [2 /*return*/, res];
                    case 2:
                        error_8 = _a.sent();
                        logger.error('getTeamForceActive failed: ', teamId, error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 接受入群邀请
     * @param options
     * options.teamId - 群id <br>
     * options.from - 邀请方的帐号
     */
    TeamStore.prototype.acceptTeamInviteActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('acceptTeamInviteActive: ', options);
                        return [4 /*yield*/, this.nim.acceptTeamInvite(options)
                            // TODO sdk 没有给任何本端和多端的有效事件，先手动处理。
                        ];
                    case 1:
                        _a.sent();
                        // TODO sdk 没有给任何本端和多端的有效事件，先手动处理。
                        this.rootStore.sysMsgStore.updateApplyMsg({
                            from: options.from,
                            type: 'teamInvite',
                            state: 'pass',
                            to: options.teamId,
                        });
                        this.rootStore.sysMsgStore.deleteUnReadSysMsgs('teamInvite', options.from, options.teamId);
                        logger.log('acceptTeamInviteActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_9 = _a.sent();
                        logger.error('acceptTeamInviteActive failed: ', options, error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 拒绝入群邀请
     * @param options
     * options.teamId - 群id <br>
     * options.from - 邀请方的帐号
     * options.ps - 附言, 选填, 开发者也可以使用JSON格式的字符串来扩展此内容
     */
    TeamStore.prototype.rejectTeamInviteActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('rejectTeamInviteActive: ', options);
                        return [4 /*yield*/, this.nim.rejectTeamInvite(options)
                            // TODO sdk 没有给任何本端和多端的有效事件，先手动处理。
                        ];
                    case 1:
                        _a.sent();
                        // TODO sdk 没有给任何本端和多端的有效事件，先手动处理。
                        this.rootStore.sysMsgStore.updateApplyMsg({
                            from: options.from,
                            type: 'teamInvite',
                            state: 'decline',
                            to: options.teamId,
                        });
                        this.rootStore.sysMsgStore.deleteUnReadSysMsgs('teamInvite', options.from, options.teamId);
                        logger.log('rejectTeamInviteActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_10 = _a.sent();
                        logger.error('rejectTeamInviteActive failed: ', options, error_10);
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 通过入群申请
     * @param options
     * options.teamId - 群id <br>
     * options.from - 邀请方的帐号
     */
    TeamStore.prototype.passTeamApplyActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('passTeamApplyActive: ', options);
                        return [4 /*yield*/, this.nim.passTeamApply(options)
                            // TODO sdk 没有给任何本端和多端的有效事件，先手动处理。
                        ];
                    case 1:
                        _a.sent();
                        // TODO sdk 没有给任何本端和多端的有效事件，先手动处理。
                        this.rootStore.sysMsgStore.updateApplyMsg({
                            from: options.from,
                            type: 'applyTeam',
                            state: 'pass',
                            to: options.teamId,
                        });
                        this.rootStore.sysMsgStore.deleteUnReadSysMsgs('applyTeam', options.from, options.teamId);
                        logger.log('passTeamApplyActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_11 = _a.sent();
                        logger.error('passTeamApplyActive failed: ', options, error_11);
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 拒绝入群申请
     * @param options
     * options.teamId - 群id <br>
     * options.from - 邀请方的帐号
     * options.ps - 附言, 选填, 开发者也可以使用JSON格式的字符串来扩展此内容
     */
    TeamStore.prototype.rejectTeamApplyActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('rejectTeamApplyActive: ', options);
                        return [4 /*yield*/, this.nim.rejectTeamApply(options)
                            // TODO sdk 没有给任何本端和多端的有效事件，先手动处理。
                        ];
                    case 1:
                        _a.sent();
                        // TODO sdk 没有给任何本端和多端的有效事件，先手动处理。
                        this.rootStore.sysMsgStore.updateApplyMsg({
                            from: options.from,
                            type: 'applyTeam',
                            state: 'decline',
                            to: options.teamId,
                        });
                        this.rootStore.sysMsgStore.deleteUnReadSysMsgs('applyTeam', options.from, options.teamId);
                        logger.log('rejectTeamApplyActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_12 = _a.sent();
                        logger.error('rejectTeamApplyActive failed: ', options, error_12);
                        throw error_12;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 添加群管理员
     * @param options
     * options.teamId - 群id <br>
     * options.accounts - 群管理员 accid
     */
    TeamStore.prototype.addTeamManagersActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('addTeamManagersActive: ', options);
                        return [4 /*yield*/, this.nim.addTeamManagers(options)];
                    case 1:
                        _a.sent();
                        logger.log('addTeamManagersActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_13 = _a.sent();
                        logger.error('addTeamManagersActive failed: ', options, error_13);
                        throw error_13;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 移除群管理员
     * @param options
     * options.teamId - 群id <br>
     * options.accounts - 群管理员 accid
     */
    TeamStore.prototype.removeTeamManagersActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('removeTeamManagersActive: ', options);
                        return [4 /*yield*/, this.nim.removeTeamManagers(options)];
                    case 1:
                        _a.sent();
                        logger.log('removeTeamManagersActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_14 = _a.sent();
                        logger.error('removeTeamManagersActive failed: ', options, error_14);
                        throw error_14;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TeamStore.prototype._onCreateTeam = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.log('_onCreateTeam: ', data);
                        return [4 /*yield*/, this._handleAddTeam(data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TeamStore.prototype._onDismissTeam = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                logger.log('_onDismissTeam: ', data);
                this._handleRemoveTeam(data.teamId);
                return [2 /*return*/];
            });
        });
    };
    TeamStore.prototype._handleAddTeam = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var team;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTeamForceActive(data.teamId)];
                    case 1:
                        team = _a.sent();
                        this.addTeam([team]);
                        return [4 /*yield*/, this.rootStore.sessionStore.insertSessionActive('team', team.teamId)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TeamStore.prototype._handleRemoveTeam = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.removeTeam([teamId]);
                        // 这里 SDK 没有给群成员离开的事件，因此在这边手动释放内存
                        this.rootStore.teamMemberStore.removeTeamMember(teamId);
                        sessionId = "team-".concat(teamId);
                        return [4 /*yield*/, this.rootStore.sessionStore.deleteSessionActive(sessionId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TeamStore.prototype._onUpdateTeam = function (data) {
        logger.log('_onUpdateTeam: ', data);
        this.updateTeam([data]);
    };
    TeamStore.prototype._onTeams = function (data) {
        logger.log('_onTeams: ', data);
        this.addTeam(data);
    };
    TeamStore.prototype._onTransferTeam = function (data) {
        logger.log('_onTransferTeam: ', data);
        this.updateTeam([data.team]);
        var members = [
            __assign(__assign({}, data.from), { account: parseSessionId(data.from.id).to }),
            __assign(__assign({}, data.to), { account: parseSessionId(data.to.id).to }),
        ];
        // @ts-ignore SDK 问题，先忽略
        this.rootStore.teamMemberStore.updateTeamMember(data.team.teamId, members);
    };
    return TeamStore;
}());

/**Mobx 可观察对象，负责管理群组成员的子 store*/
var TeamMemberStore = /** @class */ (function () {
    function TeamMemberStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.teamMembers = new Map();
        makeAutoObservable(this);
        this._onAddTeamMembers = this._onAddTeamMembers.bind(this);
        this._onRemoveTeamMembers = this._onRemoveTeamMembers.bind(this);
        this._onUpdateTeamManagers = this._onUpdateTeamManagers.bind(this);
        this._onUpdateTeamMember = this._onUpdateTeamMember.bind(this);
        this._onUpdateTeamMembersMute = this._onUpdateTeamMembersMute.bind(this);
        // 群成员添加
        nim.on('addTeamMembers', this._onAddTeamMembers);
        // 群成员离开
        nim.on('removeTeamMembers', this._onRemoveTeamMembers);
        // 群管理员更新
        nim.on('updateTeamManagers', this._onUpdateTeamManagers);
        // 群成员多端同步
        nim.on('updateTeamMember', this._onUpdateTeamMember);
        // 群成员静音
        nim.on('updateTeamMembersMute', this._onUpdateTeamMembersMute);
    }
    /**
     * 销毁TeamMemberStore，会取消相关事件监听
     */
    TeamMemberStore.prototype.destroy = function () {
        this.nim.off('addTeamMembers', this._onAddTeamMembers);
        this.nim.off('removeTeamMembers', this._onRemoveTeamMembers);
        this.nim.off('updateTeamManagers', this._onUpdateTeamManagers);
        this.nim.off('updateTeamMember', this._onUpdateTeamMember);
        this.nim.off('updateTeamMembersMute', this._onUpdateTeamMembersMute);
    };
    /**
     * 拉人入群
     * @param options
     * options.teamId - 群id <br>
     * options.accounts - 要拉进群的成员的帐号列表 <br>
     * options.ps - 附言, 选填, 开发者也可以使用JSON格式的字符串来扩展此内容 <br>
     * options.ext - 附言, 自定义扩展字段 <br>
     */
    TeamMemberStore.prototype.addTeamMemberActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.nim.addTeamMembers(options)
                            // 事件中处理
                        ];
                    case 1:
                        _a.sent();
                        // 事件中处理
                        logger.log('addTeamMemberActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger.error('addTeamMemberActive failed: ', options, error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 踢人出群
     * @param options
     * options.teamId - 群id <br>
     * options.accounts - 要拉进群的成员的帐号列表 <br>
     */
    TeamMemberStore.prototype.removeTeamMemberActive = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.nim.removeTeamMembers(options)
                            // 事件中处理
                        ];
                    case 1:
                        _a.sent();
                        // 事件中处理
                        logger.log('removeTeamMemberActive success', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        logger.error('removeTeamMemberActive failed: ', options, error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 获取群成员
     * @param teamId - 群id
     */
    TeamMemberStore.prototype.getTeamMemberActive = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('getTeamMemberActive', teamId);
                        return [4 /*yield*/, this.nim.getTeamMembers({
                                teamId: teamId,
                            })];
                    case 1:
                        res = _a.sent();
                        logger.log('getTeamMemberActive success: ', teamId, res);
                        this.addTeamMember(teamId, res);
                        return [2 /*return*/, res];
                    case 2:
                        error_3 = _a.sent();
                        logger.error('getTeamMemberActive failed: ', teamId, error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 更新我在群中的信息
     * @param options
     * options.teamId - 群id <br>
     * options.nickInTeam - 群昵称 <br>
     * options.muteTeam - 是否关闭此群的消息提醒, true表示关闭提醒, 但是SDK仍然会收到这个群的消息, SDK只是记录这个设置, 具体根据这个设置要执行的操作由第三方APP决定 <br>
     * options.bitConfigMask - 提醒策略: 0 开启提醒；1 关闭消息提醒；2 只接受管理员的消息的提醒 <br>
     * options.ext - 扩展字段 <br>
     */
    TeamMemberStore.prototype.updateMyMemberInfo = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('updateMyMemberInfo', options);
                        return [4 /*yield*/, this.nim.updateMyMemberInfo(options)];
                    case 1:
                        _a.sent();
                        logger.log('updateMyMemberInfo success: ', options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        logger.error('updateMyMemberInfo failed: ', options, error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * TeamMemberStore添加群成员处理函数（TeamMemberStore内部使用，外层不太推荐直接使用）
     * @param teamId - 群id
     * @param members - 群成员
     */
    TeamMemberStore.prototype.addTeamMember = function (teamId, members) {
        var teamMembers = this.teamMembers.get(teamId);
        if (!teamMembers) {
            teamMembers = new Map();
        }
        members
            .filter(function (item) { return !!item.valid; })
            .filter(function (item) { return !!item.account; })
            .forEach(function (item) {
            teamMembers.set(item.account, item);
        });
        this.teamMembers.set(teamId, teamMembers);
    };
    /**
     * TeamMemberStore移除群成员处理函数（TeamMemberStore内部使用，外层不太推荐直接使用）
     * @param teamId - 群id
     * @param accounts - 群成员数组
     */
    TeamMemberStore.prototype.removeTeamMember = function (teamId, accounts) {
        if (!accounts || !accounts.length) {
            this.teamMembers.delete(teamId);
            return;
        }
        var teamMembers = this.teamMembers.get(teamId);
        if (!teamMembers) {
            return;
        }
        accounts.forEach(function (item) {
            teamMembers.delete(item);
        });
        this.teamMembers.set(teamId, teamMembers);
    };
    /**
     * TeamMemberStore移除群成员处理函数（TeamMemberStore内部使用，外层不太推荐直接使用）
     * @param teamId - 群id
     * @param members - 群成员
     */
    TeamMemberStore.prototype.updateTeamMember = function (teamId, members) {
        var teamMembers = this.teamMembers.get(teamId);
        if (!teamMembers) {
            return;
        }
        members.forEach(function (item) {
            var m = teamMembers.get(item.account);
            if (m) {
                m = __assign(__assign({}, m), item);
                teamMembers.set(item.account, m);
            }
        });
        this.teamMembers.set(teamId, teamMembers);
    };
    /**
     * 从内存中获取 teamMembers
     * @param teamId - 群id
     * @param accounts - 群成员数组
     */
    TeamMemberStore.prototype.getTeamMember = function (teamId, accounts) {
        var _a;
        var teamMembers = __spreadArray([], __read((((_a = this.teamMembers.get(teamId)) === null || _a === void 0 ? void 0 : _a.values()) || [])), false);
        if (!accounts || !accounts.length) {
            return teamMembers;
        }
        return teamMembers.filter(function (item) {
            return accounts.some(function (j) { return j === item.account; });
        });
    };
    TeamMemberStore.prototype._onAddTeamMembers = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var team;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.log('_onAddTeamMembers: ', data);
                        return [4 /*yield*/, this.rootStore.teamStore.getTeamForceActive(data.team.teamId)];
                    case 1:
                        team = _a.sent();
                        this.rootStore.teamStore.addTeam([team]);
                        this.addTeamMember(data.team.teamId, data.members);
                        "team-".concat(data.team.teamId);
                        if (!data.accounts.includes(this.rootStore.userStore.myUserInfo.account)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.rootStore.sessionStore.insertSessionActive('team', data.team.teamId, false)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TeamMemberStore.prototype._onRemoveTeamMembers = function (data) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var myAccount, sessionId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // 如果自己被移除
                        // TODO 如果是自己主动退群，则提示退群成功
                        //   删除会话，如果是选中的会话，给提示 message.warning(t('onRemoveTeamText'))
                        //   删除群组
                        // 如果是其他人被移除
                        //   删除群成员
                        //   如果是选中的会话，给提示 message.info(`${rmNames.join('，')}${t('leaveTeamText')}`)
                        logger.log('_onRemoveTeamMembers: ', data);
                        this.rootStore.teamStore.updateTeam([data.team]);
                        myAccount = ((_a = this.rootStore.userStore.myUserInfo) === null || _a === void 0 ? void 0 : _a.account) || '';
                        sessionId = "team-".concat(data.team.teamId);
                        if (!data.accounts.includes(myAccount)) return [3 /*break*/, 2];
                        this.rootStore.teamStore.removeTeam([data.team.teamId]);
                        return [4 /*yield*/, this.rootStore.sessionStore.deleteSessionActive(sessionId)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.removeTeamMember(data.team.teamId, data.accounts);
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TeamMemberStore.prototype._onUpdateTeamManagers = function (data) {
        logger.log('_onUpdateTeamManagers: ', data);
        this.updateTeamMember(data.team.teamId, data.members.map(function (item) { return (__assign(__assign({}, item), { 
            // sdk 返回的 type 有问题，先根据 isManager 处理下
            type: data.isManager ? 'manager' : 'normal' })); }));
    };
    TeamMemberStore.prototype._onUpdateTeamMember = function (data) {
        logger.log('_onUpdateTeamMember: ', data);
        this.updateTeamMember(data.teamId, [data]);
    };
    TeamMemberStore.prototype._onUpdateTeamMembersMute = function (data) {
        logger.log('_onUpdateTeamMembersMute: ', data);
        this.updateTeamMember(data.team.teamId, data.members);
    };
    return TeamMemberStore;
}());

var SuperTeamStore = /** @class */ (function () {
    function SuperTeamStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.superTeams = new Map();
        makeAutoObservable(this);
        this._onDismissSuperTeam = this._onDismissSuperTeam.bind(this);
        this._onTransferSuperTeam = this._onTransferSuperTeam.bind(this);
        this._onUpdateSuperTeam = this._onUpdateSuperTeam.bind(this);
        this._onSuperTeams = this._onSuperTeams.bind(this);
        // 超级群解散
        nim.on('dismissSuperTeam', this._onDismissSuperTeam);
        // 超级群转让
        nim.on('transferSuperTeam', this._onTransferSuperTeam);
        // 超级群更新
        nim.on('updateSuperTeam', this._onUpdateSuperTeam);
        // 超级群信息
        nim.on('superTeams', this._onSuperTeams);
    }
    SuperTeamStore.prototype.destroy = function () {
        this.nim.off('dismissSuperTeam', this._onDismissSuperTeam);
        this.nim.off('transferSuperTeam', this._onTransferSuperTeam);
        this.nim.off('updateSuperTeam', this._onUpdateSuperTeam);
        this.nim.off('superTeams', this._onSuperTeams);
    };
    // async applySuperTeamActive(teamId: string): Promise<void> {
    //   const team = await this.nim.applySuperTeam({ teamId })
    //   // await this._handleAddTeam(team)
    // }
    // async leaveSuperTeamActive(teamId: string): Promise<void> {
    //   await this.nim.leaveSuperTeam({ teamId })
    //   // await this._handleRemoveTeam(teamId)
    // }
    // async dismissSuperTeamActive(teamId: string): Promise<void> {
    //   await this.nim.dismissSuperTeam({ teamId })
    //   // await this._handleRemoveTeam(teamId)
    // }
    // // 超级群禁言
    // async muteSuperTeamActive(options: MuteSuperTeamOptions): Promise<void> {
    //   await this.nim.muteSuperTeam(options)
    // }
    // 超级群消息免打扰
    // async quietsTeamActive(): Promise<void> {
    // }
    // async updateSuperTeamActive(options: UpdateSuperTeamInfoOptions): Promise<void> {
    //   await this.nim.updateSuperTeamInfo(options)
    //   // 后续在事件中处理
    // }
    SuperTeamStore.prototype.addSuperTeam = function (superTeams) {
        var _this = this;
        superTeams
            .filter(function (item) { return !!item.valid; })
            .filter(function (item) { return !!item.teamId; })
            .forEach(function (item) {
            _this.superTeams.set(item.teamId, item);
        });
    };
    SuperTeamStore.prototype.removeSuperTeam = function (teamIds) {
        var _this = this;
        teamIds.forEach(function (item) {
            _this.superTeams.delete(item);
        });
    };
    SuperTeamStore.prototype._onDismissSuperTeam = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.removeSuperTeam([data.teamId]);
                        // 这里 SDK 没有给群成员离开的事件，因此在这边手动释放内存
                        this.rootStore.superTeamMemberStore.removeSuperTeamMember(data.teamId);
                        sessionId = "superTeam-".concat(data.teamId);
                        /* TODO: onDismissTeamText
                        if (this.rootStore.uiStore.selectedSession === sessionId) {
                          message.warning(this.t('onDismissTeamText'))
                        }
                        */
                        return [4 /*yield*/, this.rootStore.sessionStore.deleteSessionActive(sessionId)];
                    case 1:
                        /* TODO: onDismissTeamText
                        if (this.rootStore.uiStore.selectedSession === sessionId) {
                          message.warning(this.t('onDismissTeamText'))
                        }
                        */
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SuperTeamStore.prototype._onUpdateSuperTeam = function (data) {
        this.addSuperTeam([data]);
    };
    SuperTeamStore.prototype._onSuperTeams = function (data) {
        this.addSuperTeam(data);
    };
    SuperTeamStore.prototype._onTransferSuperTeam = function (data) {
        this.addSuperTeam([data.team]);
        var members = [
            __assign(__assign({}, data.from), { account: parseSessionId(data.from.id).to }),
            __assign(__assign({}, data.to), { account: parseSessionId(data.to.id).to }),
        ];
        this.rootStore.superTeamMemberStore.updateSuperTeamMember(data.team.teamId, 
        // @ts-ignore SDK 问题，先忽略
        members);
    };
    return SuperTeamStore;
}());

var SuperTeamMemberStore = /** @class */ (function () {
    function SuperTeamMemberStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.teamMembers = new Map();
        makeAutoObservable(this);
        this._onAddSuperTeamMembers = this._onAddSuperTeamMembers.bind(this);
        this._onRemoveSuperTeamMembers = this._onRemoveSuperTeamMembers.bind(this);
        this._onUpdateSuperTeamManagers = this._onUpdateSuperTeamManagers.bind(this);
        this._onUpdateSuperTeamMember = this._onUpdateSuperTeamMember.bind(this);
        this._onUpdateSuperTeamMembersMute =
            this._onUpdateSuperTeamMembersMute.bind(this);
        // 超级群成员添加
        nim.on('addSuperTeamMembers', this._onAddSuperTeamMembers);
        // 超级群成员移除
        nim.on('removeSuperTeamMembers', this._onRemoveSuperTeamMembers);
        // 超级群管理员更新
        nim.on('updateSuperTeamManagers', this._onUpdateSuperTeamManagers);
        // 超级群成员更新的多端同步
        nim.on('updateSuperTeamMember', this._onUpdateSuperTeamMember);
        // 超级群成员静音
        nim.on('updateSuperTeamMembersMute', this._onUpdateSuperTeamMembersMute);
    }
    SuperTeamMemberStore.prototype.destroy = function () {
        this.nim.off('addSuperTeamMembers', this._onAddSuperTeamMembers);
        this.nim.off('removeSuperTeamMembers', this._onRemoveSuperTeamMembers);
        this.nim.off('updateSuperTeamManagers', this._onUpdateSuperTeamManagers);
        this.nim.off('updateSuperTeamMember', this._onUpdateSuperTeamMember);
        this.nim.off('updateSuperTeamMembersMute', this._onUpdateSuperTeamMembersMute);
    };
    // async addSuperTeamMemberActive(options: AddSuperTeamMembersOptions): Promise<void> {
    //   await this.nim.addSuperTeamMembers(options)
    //   // 事件中处理
    // }
    // async removeSuperTeamMemberActive(
    //   options: RemoveSuperTeamMembersOptions
    // ): Promise<void> {
    //   await this.nim.removeSuperTeamMembers(options)
    //   // 事件中处理
    // }
    SuperTeamMemberStore.prototype.addSuperTeamMember = function (teamId, members) {
        var teamMembers = this.teamMembers.get(teamId);
        if (!teamMembers) {
            teamMembers = new Map();
        }
        members
            .filter(function (item) { return item.valid; })
            .filter(function (item) { return !!item.account; })
            .forEach(function (item) {
            teamMembers.set(item.account, item);
        });
        this.teamMembers.set(teamId, teamMembers);
    };
    SuperTeamMemberStore.prototype.removeSuperTeamMember = function (teamId, accounts) {
        if (!accounts || !accounts.length) {
            this.teamMembers.delete(teamId);
            return;
        }
        var teamMembers = this.teamMembers.get(teamId);
        if (!teamMembers) {
            return;
        }
        accounts.forEach(function (item) {
            teamMembers.delete(item);
        });
        this.teamMembers.set(teamId, teamMembers);
    };
    SuperTeamMemberStore.prototype.updateSuperTeamMember = function (teamId, members) {
        var teamMembers = this.teamMembers.get(teamId);
        if (!teamMembers) {
            return;
        }
        members.forEach(function (item) {
            var m = teamMembers.get(item.account);
            if (m) {
                m = __assign(__assign({}, m), item);
                teamMembers.set(item.account, m);
            }
        });
        this.teamMembers.set(teamId, teamMembers);
    };
    SuperTeamMemberStore.prototype._onAddSuperTeamMembers = function (data) {
        this.addSuperTeamMember(data.team.teamId, data.members);
        /*
        TODO: 如果是选中的会话，就给个提示
        // 如果是选中的会话，就给个提示
        const sessionId = `superTeam-${data.team.teamId}`
        if (this.rootStore.uiStore.selectedSession === sessionId) {
          const nicks = data.members.map((item) => item.nickInTeam || item.account)
          message.info(`${nicks.join('，')}${this.t('enterTeamText')}`)
        }
        */
    };
    SuperTeamMemberStore.prototype._onRemoveSuperTeamMembers = function (data) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var myAccount, sessionId, _tms_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        myAccount = ((_a = this.rootStore.userStore.myUserInfo) === null || _a === void 0 ? void 0 : _a.account) || '';
                        sessionId = "superTeam-".concat(data.team.teamId);
                        if (!data.accounts.includes(myAccount)) return [3 /*break*/, 2];
                        this.rootStore.superTeamStore.removeSuperTeam([data.team.teamId]);
                        /* TODO: onRemoveTeamText
                        if (this.rootStore.uiStore.selectedSession === sessionId) {
                          message.warning(this.t('onRemoveTeamText'))
                        }
                        */
                        return [4 /*yield*/, this.rootStore.sessionStore.deleteSessionActive(sessionId)];
                    case 1:
                        /* TODO: onRemoveTeamText
                        if (this.rootStore.uiStore.selectedSession === sessionId) {
                          message.warning(this.t('onRemoveTeamText'))
                        }
                        */
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _tms_1 = this.teamMembers.get(data.team.teamId);
                        if (_tms_1) {
                            data.accounts
                                .map(function (item) {
                                var _t = _tms_1.get(item);
                                if (_t) {
                                    return _t.nickInTeam || _t.account;
                                }
                                return '';
                            })
                                .filter(function (item) { return !!item; });
                        }
                        this.removeSuperTeamMember(data.team.teamId, data.accounts);
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SuperTeamMemberStore.prototype._onUpdateSuperTeamManagers = function (data) {
        var members = data.members.map(function (item) { return (__assign(__assign({}, item), { 
            // 这里 SDK 返回的内容中没有 account，先自行处理一下
            account: parseSessionId(item.id).to })); });
        // @ts-ignore SDK 问题，先忽略
        this.updateSuperTeamMember(data.team.teamId, members);
    };
    SuperTeamMemberStore.prototype._onUpdateSuperTeamMember = function (data) {
        this.updateSuperTeamMember(data.teamId, [data]);
    };
    SuperTeamMemberStore.prototype._onUpdateSuperTeamMembersMute = function (data) {
        this.updateSuperTeamMember(data.team.teamId, data.members);
    };
    return SuperTeamMemberStore;
}());

/**Mobx 可观察对象，负责管理用户信息（包含陌生人）的子 store */
var UserStore = /** @class */ (function () {
    function UserStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.users = new Map();
        this.myUserInfo = {
            account: '',
            createTime: Date.now(),
            updateTime: Date.now(),
        };
        this._getUserInfo = frequencyControl(this._getUserInfos, 1000, 100);
        makeAutoObservable(this);
        this._onUsers = this._onUsers.bind(this);
        this._onSyncMyNameCard = this._onSyncMyNameCard.bind(this);
        this._onUpdateMyNameCard = this._onUpdateMyNameCard.bind(this);
        // 其他用户相关资料
        nim.on('users', this._onUsers);
        // 个人信息
        nim.on('syncMyNameCard', this._onSyncMyNameCard);
        // 多端个人信息更新
        nim.on('updateMyNameCard', this._onUpdateMyNameCard);
    }
    /**
     * 销毁UserStore，会取消相关事件监听
     */
    UserStore.prototype.destroy = function () {
        this.nim.off('users', this._onUsers);
        this.nim.off('syncMyNameCard', this._onSyncMyNameCard);
        this.nim.off('updateMyNameCard', this._onUpdateMyNameCard);
    };
    /**
     * UserStore增加users处理函数（UserStore内部使用，外层不太推荐直接使用）
     * @param users - users数组
     */
    UserStore.prototype.addUsers = function (users) {
        var _this = this;
        users
            .filter(function (item) { return !!item.account; })
            .forEach(function (item) {
            _this.users.set(item.account, item);
        });
    };
    /**
     * UserStore移除users处理函数（UserStore内部使用，外层不太推荐直接使用）
     * @param users - users数组
     */
    UserStore.prototype.removeUsers = function (accounts) {
        var _this = this;
        accounts.forEach(function (item) {
            _this.users.delete(item);
        });
    };
    /**
     * 保存个人信息
     * @param params
     * params.nick - 昵称 <br>
     * params.avatar - 头像 <br>
     * params.sign - 签名 <br>
     * params.gender - 性别 <br>
     * params.email - 邮箱 <br>
     * params.birth - 生日 <br>
     * params.tel - 手机号 <br>
     * params.ext - 扩展字段 <br>
     */
    UserStore.prototype.saveMyUserInfoActive = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('saveMyUserInfoActive', params);
                        return [4 /*yield*/, this.nim.saveMyUserInfo(params)];
                    case 1:
                        res = _a.sent();
                        this.myUserInfo = res;
                        this.addUsers([res]);
                        logger.log('saveMyUserInfoActive success', params, res);
                        return [2 /*return*/, res];
                    case 2:
                        error_1 = _a.sent();
                        logger.error('saveMyUserInfoActive failed:', params, error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 获取用户最新信息（如果内存中存在，就不去服务器取最新的了）
     * @param account - 账号id
     */
    UserStore.prototype.getUserActive = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                user = this.users.get(account);
                if (user) {
                    return [2 /*return*/, user];
                }
                return [2 /*return*/, this.getUserForceActive(account)];
            });
        });
    };
    /**
     * 获取用户最新信息（始终从服务器取最新的，用于点开用户头像时）
     * @param account - 账号id
     */
    UserStore.prototype.getUserForceActive = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var user, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._getUserInfo(account)
                            // if (user) {
                            //   this.addUsers([user])
                            // }
                            // logger.log('getUserForceActive success', account, user)
                        ];
                    case 1:
                        user = _a.sent();
                        // if (user) {
                        //   this.addUsers([user])
                        // }
                        // logger.log('getUserForceActive success', account, user)
                        return [2 /*return*/, user];
                    case 2:
                        error_2 = _a.sent();
                        logger.error('getUserForceActive failed: ', account, error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserStore.prototype._getUserInfos = function (accounts) {
        return __awaiter(this, void 0, void 0, function () {
            var users;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nim.getUsersNameCardFromServer({
                            accounts: accounts,
                        })];
                    case 1:
                        users = _a.sent();
                        this.addUsers(users);
                        return [2 /*return*/, users];
                }
            });
        });
    };
    UserStore.prototype._onUsers = function (data) {
        logger.log('_onUsers: ', data);
        this.addUsers(data);
    };
    UserStore.prototype._onSyncMyNameCard = function (data) {
        logger.log('_onSyncMyNameCard: ', data);
        this.myUserInfo = data;
        this.addUsers([data]);
    };
    UserStore.prototype._onUpdateMyNameCard = function (data) {
        logger.log('_onUpdateMyNameCard: ', data);
        this.myUserInfo = data;
        this.addUsers([data]);
    };
    return UserStore;
}());

/** Mobx 可观察对象，负责 UI 会用到的属性的子 store */
var UiStore = /** @class */ (function () {
    function UiStore(rootStore) {
        var _this = this;
        this.rootStore = rootStore;
        // TODO 这边使用 undefined 会导致无法被注册成 observable，但是 demo 上没问题，不知道是为什么，很懵逼，但是先把这边附上默认值就可以解决
        this.selectedContactType = '';
        this.selectedSession = '';
        /** @deprecated 即将废弃，过于冗杂，建议直接使用 sdk 原始数据结构结合 complexAvatar 及 getAppellation 获取头像和称谓 */
        this.p2pSessionList = [];
        /** @deprecated 即将废弃，过于冗杂，建议直接使用 sdk 原始数据结构结合 complexAvatar 及 getAppellation 获取头像和称谓 */
        this.teamSessionList = [];
        /** @deprecated 即将废弃，过于冗杂，建议直接使用 sdk 原始数据结构结合 complexAvatar 及 getAppellation 获取头像和称谓 */
        this.applyMsgList = [];
        /** @deprecated 即将废弃，UI 层自己做 */
        this.uploadFileLoading = false;
        /** @deprecated 即将废弃，UI 层自己做 */
        this.uploadImageLoading = false;
        makeAutoObservable(this);
        // this.friendsAndBlacklistHandler = reaction(
        //   () => ({
        //     friends: this.friends,
        //     blacklist: this.rootStore.relationStore.blacklist,
        //   }),
        //   this.watchFriendsAndBlacklist.bind(this)
        // )
        this.p2pSessionListHandler = reaction(function () { return ({
            sessions: _this.sessions,
            // users: this.users,
            mutes: _this.rootStore.relationStore.mutes,
            // friends: this.friends,
        }); }, debounce(this.getP2pSessionList.bind(this), 300));
        this.teamSessionListHandler = reaction(function () { return ({
            sessions: _this.sessions,
            teams: _this.teamList,
            // myTeamMemberInfos: this.myTeamMemberInfos,
        }); }, debounce(this.getTeamSessionList.bind(this), 300));
        this.applyMsgListHandler = reaction(function () { return ({
            applyMsgs: _this.applyMsgs,
        }); }, this.getApplyMsgWithInfo.bind(this));
        // this.sessionListHandler = reaction(
        //   () => ({
        //     sessions: this.sessions,
        //     users: this.users,
        //     teams: this.teamList,
        //     mutes: this.rootStore.relationStore.mutes,
        //     friends: this.friends,
        //   }),
        //   debounce(this.getSessionList.bind(this), 300)
        // )
    }
    /**
     * 销毁UiStore，使UI重置
     */
    UiStore.prototype.destroy = function () {
        // this.friendsAndBlacklistHandler()
        // this.sessionListHandler()
        this.p2pSessionListHandler();
        this.teamSessionListHandler();
        this.applyMsgListHandler();
    };
    /**
     * 通讯录选中类型
     * @param contactType - 导航类型
     */
    UiStore.prototype.selectContactType = function (contactType) {
        logger.log('selectContactType: ', contactType);
        this.selectedContactType = contactType;
    };
    /**
     * 取消通讯录选中
     */
    UiStore.prototype.unselectContactType = function () {
        logger.log('unselectContactType');
        this.selectedContactType = '';
    };
    /**
     * 切换会话
     * @param sessionId - 会话ID
     */
    UiStore.prototype.selectSession = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.log('selectSession: ', sessionId);
                        if (sessionId === this.selectedSession) {
                            return [2 /*return*/];
                        }
                        this.rootStore.msgStore.msgs.resetLimitState();
                        this.selectedSession = sessionId;
                        // 切换会话时需要做一些重置 UI 的事情
                        this.setUploadFileLoading(false);
                        this.setUploadImageLoading(false);
                        if (!sessionId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.rootStore.sessionStore.resetSession(sessionId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 取消选中会话
     */
    UiStore.prototype.unselectSession = function () {
        logger.log('unselectSession');
        this.selectedSession = '';
        this.rootStore.msgStore.msgs.resetLimitState();
    };
    /**
     * 文件上传时的loading状态
     * @param loading - 是否loading
     */
    UiStore.prototype.setUploadFileLoading = function (loading) {
        this.uploadFileLoading = loading;
    };
    /**
     * 图片上传时的loading状态
     * @param loading - 是否loading
     */
    UiStore.prototype.setUploadImageLoading = function (loading) {
        this.uploadImageLoading = loading;
    };
    /**
     * 获取群信息以及群关系
     * @param loading - 是否loading
     */
    UiStore.prototype.getTeamAndRelation = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var inTeam, team, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        logger.log('getTeamAndRelation', teamId);
                        inTeam = false;
                        team = this.rootStore.teamStore.teams.get(teamId);
                        if (!!team) return [3 /*break*/, 2];
                        // 说明不在群里
                        inTeam = false;
                        return [4 /*yield*/, this.rootStore.teamStore.getTeamForceActive(teamId)];
                    case 1:
                        team = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        inTeam = true;
                        _a.label = 3;
                    case 3:
                        logger.log('getTeamAndRelation success', { team: team, inTeam: inTeam });
                        return [2 /*return*/, { team: team, inTeam: inTeam }];
                    case 4:
                        error_1 = _a.sent();
                        logger.error('getTeamAndRelation failed: ', teamId, error_1);
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 获取用户关系
     * @param account - 账号
     */
    UiStore.prototype.getRelation = function (account) {
        var res = 'stranger';
        if (this.rootStore.userStore.myUserInfo.account === account) {
            res = 'myself';
        }
        else if (this.rootStore.friendStore.friends.has(account)) {
            res = 'friend';
        }
        else {
            res = 'stranger';
        }
        // logger.log('getRelation success', account, res)
        return {
            relation: res,
            isInBlacklist: this.rootStore.relationStore.isInBlacklist(account),
        };
    };
    /**
     * @deprecated
     * 获取群成员和备注
     * @param teamId - 群ID
     */
    UiStore.prototype.getTeamMembersWithAlias = function (teamId) {
        var _this = this;
        var _a;
        var teamMembers = __spreadArray([], __read((((_a = this.rootStore.teamMemberStore.teamMembers.get(teamId)) === null || _a === void 0 ? void 0 : _a.values()) ||
            [])), false);
        return teamMembers.map(function (item) {
            var friend = _this.rootStore.friendStore.friends.get(item.account);
            return __assign(__assign({}, friend), item);
        });
    };
    /**
     * 获取好友名片
     * * @param account - 账号
     */
    UiStore.prototype.getFriendWithUserNameCard = function (account) {
        var friend = this.rootStore.friendStore.friends.get(account) || {
            account: '',
            updateTime: Date.now(),
            createTime: Date.now(),
            valid: false,
        };
        var userCard = this.rootStore.userStore.users.get(account) || {
            account: '',
            updateTime: Date.now(),
            createTime: Date.now(),
        };
        return __assign(__assign({}, friend), userCard);
    };
    // TODO 该方法对于消息上的称谓，会不再取 msg.fromNick，这会与目前的表现不一致，原因是 SDK 还没有提供昵称变更的回调。
    /**
     * 查询用户称谓
     * 优先级按照 备注 > 群昵称 > 好友昵称 > 好友账号 返回
     * * @param account - 账号
     * * @param teamId - 群号
     * * @param ignoreAlias - 是否忽略好友备注
     * * @param nickFromMsg - 消息上的昵称，优先级位于好友昵称之后
     */
    UiStore.prototype.getAppellation = function (_a) {
        var _b;
        var account = _a.account, _c = _a.teamId, teamId = _c === void 0 ? '' : _c, _d = _a.ignoreAlias, ignoreAlias = _d === void 0 ? false : _d, _e = _a.nickFromMsg, nickFromMsg = _e === void 0 ? '' : _e;
        var friend = this.rootStore.friendStore.friends.get(account);
        var user = this.rootStore.userStore.users.get(account);
        var teamMember = (_b = this.rootStore.teamMemberStore.teamMembers
            .get(teamId)) === null || _b === void 0 ? void 0 : _b.get(account);
        return ((!ignoreAlias && (friend === null || friend === void 0 ? void 0 : friend.alias)) ||
            (teamMember === null || teamMember === void 0 ? void 0 : teamMember.nickInTeam) ||
            (user === null || user === void 0 ? void 0 : user.nick) ||
            nickFromMsg ||
            account);
    };
    Object.defineProperty(UiStore.prototype, "friends", {
        get: function () {
            return __spreadArray([], __read(this.rootStore.friendStore.friends.values()), false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiStore.prototype, "sessions", {
        get: function () {
            return __spreadArray([], __read(this.rootStore.sessionStore.sessions.values()), false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiStore.prototype, "users", {
        get: function () {
            return __spreadArray([], __read(this.rootStore.userStore.users.values()), false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiStore.prototype, "teamList", {
        get: function () {
            var teams = __spreadArray([], __read(this.rootStore.teamStore.teams.values()), false);
            return teams
                .filter(function (item) { return item.validToCurrentUser; })
                .sort(function (a, b) { return b.createTime - a.createTime; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiStore.prototype, "applyMsgs", {
        get: function () {
            return __spreadArray([], __read(this.rootStore.sysMsgStore.applyMsgs.values()), false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiStore.prototype, "sessionList", {
        // get myTeamMemberInfos(): TeamMember[] {
        //   const myAccount = this.rootStore.userStore.myUserInfo.account
        //   const teamMembers: TeamMember[] = []
        //   const _ = [...this.rootStore.teamMemberStore.teamMembers.values()]
        //   _.forEach((item) => {
        //     if (item.has(myAccount)) {
        //       teamMembers.push(item.get(myAccount)!)
        //     }
        //   })
        //   return teamMembers
        // }
        /**
         * @deprecated
         * 即将废弃，该方法过于冗杂
         * 建议使用 sessionStore.sessions 结合 ComplexAvatar、CrudeAvatar、getAppellation 完成会话列表的渲染
         */
        get: function () {
            var sessions = __spreadArray(__spreadArray([], __read(this.p2pSessionList), false), __read(this.teamSessionList), false).sort(function (a, b) { var _a, _b; return (((_a = b.lastMsg) === null || _a === void 0 ? void 0 : _a.time) || b.updateTime) - (((_b = a.lastMsg) === null || _b === void 0 ? void 0 : _b.time) || a.updateTime); });
            // 根据置顶与否重新排序
            var filterIsTop = sessions.filter(function (item) { var _a; return !!((_a = item.stickTopInfo) === null || _a === void 0 ? void 0 : _a.isStickOnTop); });
            var other = sessions.filter(function (item) { var _a; return !((_a = item.stickTopInfo) === null || _a === void 0 ? void 0 : _a.isStickOnTop); });
            return __spreadArray(__spreadArray([], __read(filterIsTop), false), __read(other), false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiStore.prototype, "sessionUnread", {
        get: function () {
            return this.sessionList
                .filter(function (item) { return !item.isMute; })
                .reduce(function (acc, cur) { return acc + cur.unread; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiStore.prototype, "friendsWithoutBlacklist", {
        /**
         * @deprecated
         * 获取好友名片列表
         * 过于冗杂，即将废弃，建议直接使用 friends 结合 complexAvatar 及 getAppellation 获取头像和称谓
         */
        get: function () {
            var _this = this;
            return this.friends
                .map(function (item) { return _this.getFriendWithUserNameCard(item.account); })
                .filter(function (item) {
                return !_this.rootStore.relationStore.blacklist.includes(item.account);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiStore.prototype, "blacklistWithUserCard", {
        /**
         * @deprecated
         * 获取黑名单名片列表
         * 过于冗杂，即将废弃，建议直接使用 blacklist 结合 complexAvatar 及 getAppellation 获取头像和称谓
         */
        get: function () {
            var _this = this;
            return this.rootStore.relationStore.blacklist.map(function (item) {
                return _this.getFriendWithUserNameCard(item);
            });
        },
        enumerable: false,
        configurable: true
    });
    // TODO reaction 确实一般是用不到的，普通的 mobx get 方法就可以实时变更。之前没有实时变更可能是一些奇怪的 bug 导致的
    // private async watchFriendsAndBlacklist({
    //   friends,
    //   blacklist,
    // }: {
    //   friends: FriendProfile[]
    //   blacklist: string[]
    // }): Promise<void> {
    //   try {
    //     logger.log('watchFriendsAndBlacklist', friends, blacklist)
    //     const userCards = await Promise.all(
    //       friends.map((item) => {
    //         return this.rootStore.userStore.getUserActive(item.account)
    //       })
    //     )
    //     const friendsWithUserCard = friends.map((item) => {
    //       const userCard = userCards.find((j) => item.account === j.account)!
    //       return {
    //         ...item,
    //         ...userCard,
    //       }
    //     })
    //     const friendsWithoutBlacklist = friendsWithUserCard.filter((i) =>
    //       blacklist.every((j) => i.account !== j)
    //     )
    //     const blacklistWithUserCard = friendsWithUserCard.filter((i) =>
    //       blacklist.includes(i.account)
    //     )
    //     runInAction(() => {
    //       this.friendsWithoutBlacklist = friendsWithoutBlacklist
    //       this.blacklistWithUserCard = blacklistWithUserCard
    //     })
    //     logger.log(
    //       'watchFriendsAndBlacklist success: ',
    //       friendsWithoutBlacklist,
    //       blacklistWithUserCard
    //     )
    //   } catch (error) {
    //     logger.error(
    //       'watchFriendsAndBlacklist failed: ',
    //       friends,
    //       blacklist,
    //       error
    //     )
    //     throw error
    //   }
    // }
    UiStore.prototype.getP2pSessionList = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var sessions, mutes_1, res_1;
            var _this = this;
            return __generator(this, function (_a) {
                try {
                    logger.log('getP2pSessionList', params);
                    sessions = params.sessions, mutes_1 = params.mutes;
                    res_1 = sessions
                        .filter(function (item) { return item.scene === 'p2p'; })
                        .map(function (item) {
                        // const userCard = finalUsers.find((j) => j.account === item.to)!
                        var isMute = mutes_1.some(function (j) { return j === item.to; });
                        // const friend = friends.find((j) => j.account === item.to)!
                        return __assign(__assign({}, item), { 
                            // ...friend,
                            // ...userCard,
                            // updateTime: item.updateTime,
                            isMute: isMute });
                    });
                    runInAction(function () {
                        _this.p2pSessionList = res_1;
                    });
                    logger.log('getP2pSessionList success', params, res_1);
                    return [2 /*return*/, res_1];
                }
                catch (error) {
                    logger.error('getP2pSessionList failed: ', params, error);
                    throw error;
                }
                return [2 /*return*/];
            });
        });
    };
    UiStore.prototype.getTeamSessionList = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var sessions, finalTeams_1, res_2, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('getTeamSessionList', params);
                        sessions = params.sessions;
                        return [4 /*yield*/, Promise.allSettled(sessions
                                .filter(function (item) { return item.scene === 'team'; })
                                .map(function (item) {
                                return _this.rootStore.teamStore.getTeamActive(item.to);
                            }))];
                    case 1:
                        finalTeams_1 = (_a.sent())
                            .filter(function (item) { return item.status === 'fulfilled'; })
                            .map(function (item) { return item.value; });
                        res_2 = sessions
                            .filter(function (item) { return item.scene === 'team'; })
                            .filter(function (item) { return finalTeams_1.some(function (j) { return j.teamId === item.to; }); })
                            .map(function (item) {
                            var team = finalTeams_1.find(function (j) { return j.teamId === item.to; });
                            return __assign(__assign(__assign({}, item), team), { updateTime: item.updateTime });
                        });
                        runInAction(function () {
                            _this.teamSessionList = res_2;
                        });
                        logger.log('getTeamSessionList success', params, res_2);
                        return [2 /*return*/, res_2];
                    case 2:
                        error_2 = _a.sent();
                        logger.error('getTeamSessionList failed: ', params, error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UiStore.prototype.getApplyMsgWithInfo = function (_a) {
        var _b, _c, _d;
        var applyMsgs = _a.applyMsgs;
        return __awaiter(this, void 0, void 0, function () {
            var res, applyMsgs_1, applyMsgs_1_1, item, _e, fromUser, toTeam, fromUser, toTeam, fromTeam, fromUser, fromUser, e_1_1;
            var e_1, _f;
            var _this = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        res = [];
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 18, 19, 20]);
                        applyMsgs_1 = __values(applyMsgs), applyMsgs_1_1 = applyMsgs_1.next();
                        _g.label = 2;
                    case 2:
                        if (!!applyMsgs_1_1.done) return [3 /*break*/, 17];
                        item = applyMsgs_1_1.value;
                        _e = item.type;
                        switch (_e) {
                            case 'applyTeam': return [3 /*break*/, 3];
                            case 'teamInvite': return [3 /*break*/, 6];
                            case 'rejectTeamApply': return [3 /*break*/, 8];
                            case 'rejectTeamInvite': return [3 /*break*/, 9];
                            case 'friendRequest': return [3 /*break*/, 11];
                        }
                        return [3 /*break*/, 15];
                    case 3: return [4 /*yield*/, this.rootStore.userStore.getUserActive(item.from)];
                    case 4:
                        fromUser = _g.sent();
                        return [4 /*yield*/, this.rootStore.teamStore.getTeamActive(item.to)];
                    case 5:
                        toTeam = _g.sent();
                        res.push(__assign(__assign({}, item), { attach: __assign(__assign({}, item.attach), { fromUser: fromUser, toTeam: toTeam }) }));
                        return [3 /*break*/, 16];
                    case 6: return [4 /*yield*/, this.rootStore.userStore.getUserActive(item.from)
                        // 这里 sdk 自带了 Team
                    ];
                    case 7:
                        fromUser = _g.sent();
                        toTeam = (_b = item.attach) === null || _b === void 0 ? void 0 : _b.team;
                        res.push(__assign(__assign({}, item), { attach: __assign(__assign({}, item.attach), { fromUser: fromUser, toTeam: toTeam }) }));
                        return [3 /*break*/, 16];
                    case 8:
                        {
                            fromTeam = (_c = item.attach) === null || _c === void 0 ? void 0 : _c.team;
                            res.push(__assign(__assign({}, item), { attach: __assign(__assign({}, item.attach), { fromTeam: fromTeam }) }));
                            return [3 /*break*/, 16];
                        }
                    case 9: return [4 /*yield*/, this.rootStore.userStore.getUserActive(item.from)];
                    case 10:
                        fromUser = _g.sent();
                        res.push(__assign(__assign({}, item), { attach: __assign(__assign({}, item.attach), { fromUser: fromUser }) }));
                        return [3 /*break*/, 16];
                    case 11:
                        if (!['applyFriend', 'rejectFriendApply', 'passFriendApply'].includes((_d = item.attach) === null || _d === void 0 ? void 0 : _d.type)) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.rootStore.userStore.getUserActive(item.from)];
                    case 12:
                        fromUser = _g.sent();
                        res.push(__assign(__assign({}, item), { attach: __assign(__assign({}, item.attach), { fromUser: fromUser }) }));
                        return [3 /*break*/, 14];
                    case 13:
                        res.push(item);
                        _g.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        res.push(item);
                        return [3 /*break*/, 16];
                    case 16:
                        applyMsgs_1_1 = applyMsgs_1.next();
                        return [3 /*break*/, 2];
                    case 17: return [3 /*break*/, 20];
                    case 18:
                        e_1_1 = _g.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 20];
                    case 19:
                        try {
                            if (applyMsgs_1_1 && !applyMsgs_1_1.done && (_f = applyMsgs_1.return)) _f.call(applyMsgs_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 20:
                        // 按时间倒叙排序
                        res.sort(function (a, b) { return b.time - a.time; });
                        runInAction(function () {
                            _this.applyMsgList = res;
                        });
                        logger.log('getApplyMsgWithInfo success', applyMsgs, res);
                        return [2 /*return*/, res];
                }
            });
        });
    };
    return UiStore;
}());

/**Mobx 可观察对象，负责 IM 的事件订阅与发布 */
var EventStore = /** @class */ (function () {
    function EventStore(rootStore, nim) {
        this.rootStore = rootStore;
        this.nim = nim;
        this.stateMap = new Map();
        makeAutoObservable(this);
        this._onPushEvents = this._onPushEvents.bind(this);
        // 收到事件
        nim.on('pushEvents', this._onPushEvents);
    }
    /** 销毁 EventStore，并取消相关的监听 */
    EventStore.prototype.destroy = function () {
        this.nim.off('pushEvents', this._onPushEvents);
    };
    /**
     * 订阅登录状态
     * @param accounts 账号
     */
    EventStore.prototype.subscribeLoginStateActive = function (accounts) {
        return __awaiter(this, void 0, void 0, function () {
            var filterAccounts, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        logger.log('subscribeLoginStateActive', accounts);
                        filterAccounts = accounts.filter(function (item) { return !_this.stateMap.get(item); });
                        if (!filterAccounts.length) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.nim.subscribeEvent({
                                accounts: filterAccounts,
                                type: 1,
                                sync: true,
                                // 订阅一天
                                subscribeTime: 86400,
                            })];
                    case 1:
                        _a.sent();
                        logger.log('subscribeLoginStateActive success', accounts, filterAccounts);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger.error('subscribeLoginStateActive failed', accounts, error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EventStore.prototype._onPushEvents = function (data) {
        var _this = this;
        logger.log('_onPushEvents', data);
        data.forEach(function (item) {
            var _a;
            // 不等于 1 的先忽略不处理
            if (item.type !== 1) {
                return;
            }
            var serverConfig = { online: [] };
            try {
                // @ts-ignore SDK 漏了这个类型
                serverConfig = JSON.parse(item.serverConfig);
            }
            catch (error) {
                // 忽略
            }
            // 收到上线就表示上线
            if (item.value === 1) {
                _this.stateMap.set(item.account, 'online');
            }
            else {
                // 收到其他的，根据 online 继续判断是否在线
                _this.stateMap.set(item.account, ((_a = serverConfig.online) === null || _a === void 0 ? void 0 : _a.length) ? 'online' : 'offline');
            }
        });
    };
    return EventStore;
}());

var RootStore = /** @class */ (function () {
    function RootStore(nim, localOptions) {
        var _this = this;
        this.localOptions = {
            addFriendNeedVerify: true,
            teamBeInviteMode: 'needVerify',
            teamJoinMode: 'noVerify',
            teamInviteMode: 'manager',
            teamUpdateTeamMode: 'manager',
            teamUpdateExtMode: 'manager',
            leaveOnTransfer: false,
            needMention: true,
            p2pMsgReceiptVisible: false,
            teamMsgReceiptVisible: false,
            loginStateVisible: false,
            allowTransferTeamOwner: false,
            teamManagerVisible: false,
            teamManagerLimit: 10,
            sendMsgBefore: function (options) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, options];
            }); }); },
        };
        logger.log('store init');
        makeAutoObservable(this);
        this.nim = nim;
        this.localOptions = __assign(__assign({}, this.localOptions), localOptions);
        this.connectStore = new ConnectStore(this, nim);
        this.friendStore = new FriendStore(this, nim);
        this.msgStore = new MsgStore(this, nim, this.localOptions);
        this.sysMsgStore = new SysMsgStore(this, nim);
        this.relationStore = new RelationStore(this, nim);
        this.sessionStore = new SessionStore(this, nim);
        this.teamStore = new TeamStore(this, nim, this.localOptions);
        this.teamMemberStore = new TeamMemberStore(this, nim);
        this.superTeamStore = new SuperTeamStore(this, nim);
        this.superTeamMemberStore = new SuperTeamMemberStore(this, nim);
        this.userStore = new UserStore(this, nim);
        this.eventStore = new EventStore(this, nim);
        this.uiStore = new UiStore(this);
    }
    /**
     * 销毁根store实例
     */
    RootStore.prototype.destroy = function () {
        logger.log('store destroyed');
        this.connectStore.destroy();
        this.friendStore.destroy();
        this.msgStore.destroy();
        this.sysMsgStore.destroy();
        this.relationStore.destroy();
        this.sessionStore.destroy();
        this.teamStore.destroy();
        this.teamMemberStore.destroy();
        this.superTeamStore.destroy();
        this.superTeamMemberStore.destroy();
        this.userStore.destroy();
        this.eventStore.destroy();
        this.uiStore.destroy();
    };
    /**
     * 获取根store实例
     * @param nim NIM SDK 实例
     * @param t 国际化函数
     */
    RootStore.getInstance = function (nim, localOptions) {
        if (!this.ins) {
            this.ins = new RootStore(nim, localOptions);
        }
        return this.ins;
    };
    return RootStore;
}());

export { ConnectStore, FriendStore, MsgStore, RelationStore, RootStore, SessionStore, SysMsgStore, TeamMemberStore, TeamStore, UiStore, UserStore, RootStore as default, constant as storeConstants, utils as storeUtils };
